import React, { useState, useRef, useEffect, useMemo } from "react";
import PaginationBar from "../../UILibrary/PaginationBar";
import PdfImportButton from "../Marketplace/PdfImportButton";
import UserProfileComponent from "../SellerProfile/UserProfileComponent";
import Overlay from "../../UILibrary/Overlay";
import Select from "react-select";
import "../Dashboard.css";
import rfpIcon from "../../../assets/rfpicon.svg";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { Dialog } from "@headlessui/react";
import { useLocation } from "react-router-dom";
import { sendMessage } from "../../../store/messagesSlice";
import {
  deleteSupplier,
  deleteSupplieById,
  deleteSavedSupplier,
  getAllSuppliers,
  bulkDeleteSuppliers,
  sendRequestMessage,
  fetchPendingSuppliers,
  getFolderCountsByBuyerId,
  getFilteredManagementSuppliers,
  sendInvite,
  moveSupplierToFolder,
} from "../../../store/suppliersManagementSlice";
import { setSelectedSupplier } from "../../../store/authSlice";
import {
  searchSuppliersByPromtText,
  analyzeRfpById,
  searchSuppliers,
} from "../../../store/rfpSlice";

const industries = [
  { code: "11", name: "Agriculture, Forestry, Fishing and Hunting" },
  { code: "21", name: "Mining, Quarrying, and Oil and Gas Extraction" },
  { code: "22", name: "Utilities" },
  { code: "23", name: "Construction" },
  { code: "31-33", name: "Manufacturing" },
  { code: "42", name: "Wholesale Trade" },
  { code: "44-45", name: "Retail Trade" },
  { code: "48-49", name: "Transportation and Warehousing" },
  { code: "51", name: "Information" },
  { code: "52", name: "Finance and Insurance" },
  { code: "53", name: "Real Estate and Rental and Leasing" },
  { code: "54", name: "Professional, Scientific, and Technical Services" },
  { code: "55", name: "Management of Companies and Enterprises" },
  {
    code: "56",
    name: "Administrative and Support and Waste Management and Remediation Services",
  },
  { code: "61", name: "Educational Services" },
  { code: "62", name: "Health Care and Social Assistance" },
  { code: "71", name: "Arts, Entertainment, and Recreation" },
  { code: "72", name: "Accommodation and Food Services" },
  { code: "81", name: "Other Services (except Public Administration)" },
];
const certifications = ["Certified", "Uncertified"];

const countryOptions = [
  { value: "US", label: "US" },
  { value: "Canada", label: "Canada" },
];

const stateOptions = {
  US: [
    { value: "Alabama", label: "Alabama" },
    { value: "Alaska", label: "Alaska" },
    { value: "Arizona", label: "Arizona" },
    { value: "Arkansas", label: "Arkansas" },
    { value: "California", label: "California" },
    { value: "Colorado", label: "Colorado" },
    { value: "Connecticut", label: "Connecticut" },
    { value: "Delaware", label: "Delaware" },
    { value: "Florida", label: "Florida" },
    { value: "Georgia", label: "Georgia" },
    { value: "Hawaii", label: "Hawaii" },
    { value: "Idaho", label: "Idaho" },
    { value: "Illinois", label: "Illinois" },
    { value: "Indiana", label: "Indiana" },
    { value: "Iowa", label: "Iowa" },
    { value: "Kansas", label: "Kansas" },
    { value: "Kentucky", label: "Kentucky" },
    { value: "Louisiana", label: "Louisiana" },
    { value: "Maine", label: "Maine" },
    { value: "Maryland", label: "Maryland" },
    { value: "Massachusetts", label: "Massachusetts" },
    { value: "Michigan", label: "Michigan" },
    { value: "Minnesota", label: "Minnesota" },
    { value: "Mississippi", label: "Mississippi" },
    { value: "Missouri", label: "Missouri" },
    { value: "Montana", label: "Montana" },
    { value: "Nebraska", label: "Nebraska" },
    { value: "Nevada", label: "Nevada" },
    { value: "New Hampshire", label: "New Hampshire" },
    { value: "New Jersey", label: "New Jersey" },
    { value: "New Mexico", label: "New Mexico" },
    { value: "New York", label: "New York" },
    { value: "North Carolina", label: "North Carolina" },
    { value: "North Dakota", label: "North Dakota" },
    { value: "Ohio", label: "Ohio" },
    { value: "Oklahoma", label: "Oklahoma" },
    { value: "Oregon", label: "Oregon" },
    { value: "Pennsylvania", label: "Pennsylvania" },
    { value: "Rhode Island", label: "Rhode Island" },
    { value: "South Carolina", label: "South Carolina" },
    { value: "South Dakota", label: "South Dakota" },
    { value: "Tennessee", label: "Tennessee" },
    { value: "Texas", label: "Texas" },
    { value: "Utah", label: "Utah" },
    { value: "Vermont", label: "Vermont" },
    { value: "Virginia", label: "Virginia" },
    { value: "Washington", label: "Washington" },
    { value: "West Virginia", label: "West Virginia" },
    { value: "Wisconsin", label: "Wisconsin" },
    { value: "Wyoming", label: "Wyoming" },
  ],
  Canada: [
    { value: "Alberta", label: "Alberta" },
    { value: "British Columbia", label: "British Columbia" },
    { value: "Manitoba", label: "Manitoba" },
    { value: "New Brunswick", label: "New Brunswick" },
    { value: "Newfoundland and Labrador", label: "Newfoundland and Labrador" },
    { value: "Nova Scotia", label: "Nova Scotia" },
    { value: "Ontario", label: "Ontario" },
    { value: "Prince Edward Island", label: "Prince Edward Island" },
    { value: "Quebec", label: "Quebec" },
    { value: "Saskatchewan", label: "Saskatchewan" },
    { value: "Northwest Territories", label: "Northwest Territories" },
    { value: "Nunavut", label: "Nunavut" },
    { value: "Yukon", label: "Yukon" },
  ],
};

const industryOptions = industries.map((industry) => ({
  value: industry.name,
  label: industry.name,
}));

const certificationOptions = certifications.map((cert) => ({
  value: cert,
  label: cert,
}));
const customStyles = {
  menu: (provided) => ({
    ...provided,
    textAlign: "start",
    background: "#F7F7F7",
    borderRadius: "0.5rem",
    padding: "10px",
  }),
  menuList: (provided) => ({
    ...provided,
    maxHeight: "220px",
    overflowY: "auto",
    paddingRight: "6px", // optional: prevent scrollbar overlay
  }),
  control: (provided, state) => ({
    ...provided,
    border: "none",
    background: "#F5F5F5",
    textAlign: "start",
    height: "48px",
    borderRadius: "0.5rem",
    boxShadow: state.isFocused
      ? "0 0 0 2px rgba(128, 128, 128, 0.5)"
      : provided.boxShadow,
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#1D2639",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? "#F5F5F5"
      : state.isFocused
      ? "#F5F5F5"
      : provided.backgroundColor,
    color: "black",
    padding: "6px",
    borderRadius: "0.5rem",
    "&:active": {
      backgroundColor: "#F5F5F5",
    },
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#B0B0B0",
  }),
};
const customMultiSelectStyles = {
  menu: (provided) => ({
    ...provided,
    textAlign: "start",
    background: "#F7F7F7",
    padding: "10px",
  }),
  menuList: (provided) => ({
    ...provided,
    maxHeight: "220px",
    overflowY: "auto",
    paddingRight: "6px",
  }),
  control: (provided, state) => ({
    ...provided,
    ...provided,
    border: "none",
    background: "#F9F9F9",
    textAlign: "start",
    minHeight: "48px",
    height: "auto",
    boxShadow: state.isFocused
      ? "0 0 0 2px rgba(128, 128, 128, 0.5)"
      : provided.boxShadow,
    overflowY: "hidden",
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#1D2639",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? "lightgray"
      : state.isFocused
      ? "lightgray"
      : provided.backgroundColor,
    color: state.isSelected ? "black" : "black",
    padding: "6px",
    "&:active": {
      backgroundColor: "lightgray",
    },
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#B0B0B0",
  }),
};
const CompanyTable = ({
  handleEdit,
  isSavedSuppliers,
  selectedFolderName,
  isFiltered,
}) => {
  const [isUserProfileOpen, setIsUserProfileOpen] = useState(false);
  const [selectedCard, setSelectedCard] = useState(false);
  const [isClosed, setIsClosed] = useState(false);
  const dotsMenuRef = useRef();
  const deleteWindowRef = useRef();
  const [currentPage, setCurrentPage] = useState(1);
  const [menuVisibility, setMenuVisibility] = useState({});
  const [isDotsMenuOpen, setDotsMenuOpen] = useState(false);
  const [supplierToDelete, setSupplierToDelete] = useState(null);
  const [showConfirmation, setShowConfirmation] = useState(null);
  const [message, setMessage] = useState("");
  const [isSummuryGenerated, setSummuryGenerated] = useState(false);
  const [isSearchInProgress, setSearchInProgress] = useState(false);
  const folders = useSelector((state) => state.suppliers?.folders);
  const [error, setError] = useState("");
  const [step, setStep] = useState(1);
  const [isSearchTrigered, setSearchTrigered] = useState(false);
  const [isMoreSuppliersClicked, setMoreSuppliersClicked] = useState(false);
  const [inviteMessage, setInviteMessage] = useState(
    "We’d love to connect and collaborate with you!"
  );
  const [isSuccess, setIsSuccess] = useState(false);
  const [isRecommendedSuppliersLoaded, setRecommendedSuppliersLoaded] =
    useState(false);
  const recommendedSuppliers = useSelector((state) => state.rfp?.recSuppliers);
  const [searchQuery, setSearchQuery] = useState("");
  const [tempSearchQuery, setTempSearchQuery] = useState("");
  const location = useLocation();
  const isPanelOpen = location.state?.isPanelOpen;
  const allSuppliers = useSelector((state) => state.suppliers.suppliers);
  const filteredSuppliers = useSelector(
    (state) => state.suppliers.filteredSuppliers
  );
  const [isFilteringDone, setFilteringDone] = useState(false);
  const suppliersByFolder = useSelector(
    (state) => state.suppliers.suppliersByFolder
  );
  const { summaryText, analyzing, fileId } = useSelector((state) => state.rfp);
  const searchSuppliersData = useSelector((state) => state.rfp.searchSuppliers);
  const totalSuppliers = useSelector((state) => state.suppliers.totalSuppliers);
  const pendingSuppliers = useSelector(
    (state) => state.suppliers.pendingSuppliers
  );
  const totalPendingSuppliers = useSelector(
    (state) => state.suppliers.totalPendingSuppliers
  );
  const savedSuppliers = useSelector((state) => state.suppliers.saved);
  const [showRequestConfirmation, setShowRequestConfirmation] = useState(false);
  const [isDeletedSupplier, setDeletedSupplier] = useState(false);
  const [isMultipleMenuClicked, setMultipleMenuClicked] = useState(false);
  const [isPendingOpen, setPendingOpen] = useState(false);
  const [isCheckboxVisible, setCheckboxVisible] = useState(false);
  const [isSelect, setSelect] = useState(true);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedSuppliers, setSelectedSuppliers] = useState([]);
  const [isSelectionMenuClicked, setSelectionMenuClicked] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [isDeletetriggered, setDeleteTriggered] = useState(false);
  const userId = useSelector((state) => state.auth.id);
  const user = useSelector((state) => state.auth.userDetails.userDetails);
  const [isImportCompleted, setImportCompleted] = useState(false);
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedFolder, setSelectedFolder] = useState(null);
  const [isMoveToFolderActive, setMoveToFolderActive] = useState(false);

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedSupplier(null);
    setMessage("");
  };
  const handleBulkCloseModal = () => {
    setIsBulkModalOpen(false);
    setSelectedSuppliers([]);
    setBulkMessage("");
  };

  const [selectedFilters, setSelectedFilters] = useState({
    Country: [],
    State: [],
    Industry: { code: "", name: "" },
    NAICS: [],
    Certification: [],
    City: [],
  });
  const [cityInput, setCityInput] = useState("");
  const [naicsData, setNaicsData] = useState([]);
  const [NaicsCodes, setNaicsCodes] = useState([]);
  const [isIndustrySelected, setIndustrySelected] = useState(false);

  const [selectedCompany, setSelectedCompany] = useState(null);
  const [bulkSubject, setBulkSubject] = useState("");
  const [bulkMessage, setBulkMessage] = useState("");
  const [isBulkModalOpen, setIsBulkModalOpen] = useState(false);

  const handleIndustryChange = (selectedOption) => {
    const selectedValue = selectedOption ? selectedOption.value : "";
    const selectedLabel = selectedOption ? selectedOption.label : "";
    setSelectedFilters((prev) => ({
      ...prev,
      Industry: { code: selectedValue, name: selectedLabel },

      NAICS: [],
    }));
    setIndustrySelected(true);
  };
  const handleAdditionalNaicsChange = (selectedOptions) => {
    const selectedCodes = selectedOptions?.map((option) => option.value) || [];

    setNaicsCodes(selectedCodes);

    setSelectedFilters((prev) => ({
      ...prev,
      NAICS: selectedCodes,
    }));
  };
  const BASE_API_URL =
    "https://api.census.gov/data/2022/ecnbasic?get=NAICS2022,NAICS2022_LABEL,NAME,GEO_ID,ESTAB,RCPTOT,EMP&for=us:*&key=ca9f7d90d4ea4a77f056e0a1ea74f0a8660366b6";

  useEffect(() => {
    if (selectedFilters.Industry.code) {
      const apiUrl = `${BASE_API_URL}&NAICS2022=${selectedFilters.Industry.code}*`;
      fetch(apiUrl)
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json();
        })
        .then((data) => {
          if (data.length > 1) {
            const formattedData = data
              .slice(1)
              .map(([code, description, ...rest]) => ({
                value: code,
                label: `${code} - ${description}`,
                additionalInfo: rest,
              }));
            setNaicsData(formattedData);
          } else {
            setNaicsData([]);
          }
        })
        .catch((error) => {
          console.error("Error fetching NAICS data:", error);
          setNaicsData([]);
        });
    }
  }, [selectedFilters.Industry]);

  const handleRequestSubmission = (company) => {
    setSelectedCompany(company);
    setShowRequestConfirmation(true);
  };

  const handleCancelRequest = () => {
    setShowRequestConfirmation(false);
    setMessage("");
    setSelectedCompany(null);
  };

  const handleCancel = () => {
    setShowFilters(false);
    setSelectedFilters({
      Country: [],
      State: [],
      Industry: [],
      Certification: [],
      City: [],
    });
    setCityInput("");
  };

  const handleFilters = () => {
    const buyerIdToUse = user?.isTestUser ? user?.id : userId;
    const filters = {
      country: selectedFilters.Country,
      state: selectedFilters.State,
      identifierNAICSCode: selectedFilters.NAICS,
      certification: selectedFilters.Certification,
      city: selectedFilters.City,
    };

    dispatch(getFilteredManagementSuppliers({ filters, buyerId: buyerIdToUse }))
      .unwrap()
      .then(() => {
        setFilteringDone(true);
      })
      .catch((error) => {
        console.error("Filtering failed:", error);
      });

    setShowFilters(false);
    setSelectedFilters({
      Country: [],
      State: [],
      Industry: [],
      Certification: [],
      City: [],
    });
    setCityInput("");
  };

  const regenerateText = () => {
    dispatch(analyzeRfpById(fileId));
  };

  const handleSearch = () => {
    setTempSearchQuery(searchQuery);
    dispatch(searchSuppliersByPromtText({ text: searchQuery }));
    setSearchInProgress(true);
    setSearchTrigered(true);
    setSearchQuery("");
  };
  useEffect(() => {
    if (isSummuryGenerated || isSearchTrigered) {
      const timer = setTimeout(() => {
        setSummuryGenerated(false);
        setSearchTrigered(false);
        setRecommendedSuppliersLoaded(true);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [isSummuryGenerated, isSearchTrigered]);

  const handleSelectChange = (type, selectedOptions) => {
    setSelectedFilters((prev) => ({
      ...prev,
      [type]: selectedOptions ? selectedOptions.map((opt) => opt.value) : [],
    }));
  };
  const removeTag = (type, value) => {
    setSelectedFilters((prev) => ({
      ...prev,
      [type]: prev[type].filter((v) => v !== value),
    }));
  };

  const closePopUp = () => {
    isSummuryGenerated ? setSummuryGenerated(false) : setImportCompleted(false);
  };

  const onNext = () => {
    setImportCompleted(false);
    setSummuryGenerated(true);
    dispatch(searchSuppliers({ text: summaryText }));
  };
  const handleCitySubmit = () => {
    if (cityInput.trim() && !selectedFilters.City.includes(cityInput.trim())) {
      setSelectedFilters((prev) => ({
        ...prev,
        City: [...prev.City, cityInput.trim()],
      }));
      setCityInput("");
    }
  };

  const handleChange = (event) => {
    setMessage(event.target.value);
  };

  const handleDone = () => {
    setDeletedSupplier(false);
    setMoveToFolderActive(false);
    setStep(1);
    setSelectedCompany(null);
    setSelectedFolder(null);
  };

  const handleMultipleMenu = () => {
    setMultipleMenuClicked(!isMultipleMenuClicked);
    setCheckboxVisible(!isCheckboxVisible);

    if ((isSelect || selectAll) && selectedSuppliers.length > 0) {
      setCheckboxVisible(true);
      setMultipleMenuClicked(false);
      setSelectionMenuClicked(!isSelectionMenuClicked);
    }
  };

  const handleClearSelection = () => {
    setSelectedSuppliers([]);
    setSelectionMenuClicked(false);
    setCheckboxVisible(false);
  };

  const handleDeleteSelection = async () => {
    const supplierIds = selectedSuppliers.map((supplier) => supplier._id);
    const buyerIdToUse = user?.isTestUser ? user?.id : userId;

    if (supplierIds.length > 0) {
      try {
        await dispatch(
          bulkDeleteSuppliers({ supplierIds, buyerId: buyerIdToUse })
        ).unwrap();

        dispatch(
          getAllSuppliers({
            page: 1,
            limit: itemsPerPage,
            buyerId: buyerIdToUse,
          })
        );

        setDeleteTriggered(true);
        setSelectedSuppliers([]);
        setSelectionMenuClicked(false);
        setCheckboxVisible(false);
      } catch (error) {
        console.error("Failed to delete suppliers:", error);
      }
    }
  };

  const handleSendInvite = (supplier) => {
    setSelectedCompany(supplier);
    setShowRequestConfirmation(true);
    setSelectionMenuClicked(false);
    setCheckboxVisible(false);
  };
  const handleSendInviteInBulk = (supplier) => {
    setSelectionMenuClicked(false);
    setCheckboxVisible(false);
  };

  const handleRequestInfo = () => {
    setSelectionMenuClicked(false);
    setCheckboxVisible(false);
    setShowRequestConfirmation(true);
  };

  useEffect(() => {
    if ((isSelect || selectAll) && selectedSuppliers.length > 0) {
      setSelectionMenuClicked(true);
      setMultipleMenuClicked(false);
    }
    setSelectionMenuClicked(false);
  }, [isSelect, selectAll, selectedSuppliers]);

  const handleSelectAllChange = () => {
    setSelectAll(!selectAll);
    if (!selectAll) {
      setSelectedSuppliers(allSuppliers);
    } else {
      setSelectedSuppliers([]);
    }
  };

  const handleSelectMenuClick = (company) => {
    const existingIndex = selectedSuppliers.findIndex(
      (supplier) => supplier._id === company._id
    );

    if (existingIndex !== -1) {
      setSelectedSuppliers((prev) =>
        prev.filter((supplier) => supplier._id !== company._id)
      );
    } else {
      setSelectedSuppliers((prev) => [...prev, company]);
    }
  };

  const handleRequestConfirmation = (supplierId) => {
    setShowRequestConfirmation(false);
    const payload = {
      supplierId: supplierId,
      buyerId: userId,
      message: inviteMessage,
    };

    dispatch(sendInvite(payload));
  };

  const handleDeleteClick = (supplier) => {
    setShowConfirmation(true);
    setSupplierToDelete(supplier);
    toggleMenu(supplier._id);
  };

  const handleConfirmDelete = async () => {
    const buyerIdToUse = user?.isTestUser ? user?.id : userId;

    if (!supplierToDelete?._id) {
      setShowConfirmation(false);
      return;
    }

    if (isSavedSuppliers) {
      await dispatch(
        deleteSavedSupplier({
          buyerId: buyerIdToUse,
          supplierId: supplierToDelete._id,
        })
      );
    } else {
      const result = await dispatch(
        deleteSupplieById({
          supplierId: supplierToDelete._id,
          buyerId: buyerIdToUse,
        })
      );

      if (deleteSupplieById.fulfilled.match(result)) {
        dispatch(deleteSupplier(supplierToDelete));
        dispatch(
          getAllSuppliers({
            page: currentPage,
            limit: itemsPerPage,
            buyerId: buyerIdToUse,
          })
        );
        dispatch(getFolderCountsByBuyerId(buyerIdToUse));
        setDeleteTriggered((prev) => !prev);
      }
    }

    setSupplierToDelete(null);
    setShowConfirmation(false);
    setDeletedSupplier(true);
  };

  const handleCancelDelete = () => {
    setSupplierToDelete(null);
    setShowConfirmation(false);
  };
  const handleSendMessage = (supplier) => {
    setSelectedCompany(supplier);
    setIsModalOpen(true);
  };

  const handleSend = () => {
    if (!message.trim()) return;

    dispatch(
      sendMessage({
        supplierId: selectedCompany._id,
        message: {
          username: "You",
          type: "sent",
          content: {
            text: message,
            file: null,
            image: null,
          },
          timestamp: new Date().toISOString(),
        },
        supplier: selectedCompany,
      })
    );

    setTimeout(() => {
      setIsSuccess(true);
    }, 500);
  };

  const handleMove = () => {
    const buyerId = userId;
    const supplierId = selectedCompany._id;

    if (selectedCompany.addToFolder === selectedFolder) {
      setError(
        "The supplier already exists in the folder you are trying to move them into. Please select a different folder."
      );
    } else {
      dispatch(moveSupplierToFolder({ supplierId, buyerId, newFolderName: selectedFolder }));
      setError("");
      setStep(2);
    }
  };

  const handleCloseSuccess = () => {
    setIsSuccess(false);
    handleCloseModal();
    handleBulkCloseModal();
  };
  const handleSendBulkMessage = () => {
    if (!bulkMessage.trim() || selectedSuppliers.length === 0) return;

    const suppliersPayload = selectedSuppliers.map((s) => ({
      supplierId: s._id,
      supplier: s,
    }));

    dispatch(
      sendMessage({
        suppliers: suppliersPayload,
        subject: bulkSubject,
        message: {
          username: "You",
          type: "sent",
          content: {
            text: bulkMessage,
            file: null,
            image: null,
          },
          timestamp: new Date().toISOString(),
        },
      })
    );
    setTimeout(() => {
      setIsSuccess(true);
    }, 500);

    setBulkSubject("");
    setBulkMessage("");
  };

  const handleCloseUserProfile = () => {
    setSelectedCard(false);
    setIsUserProfileOpen(false);
    setIsClosed(true);
  };
  const handleCardSelection = (supplier) => {
    if (isClosed) {
      setSelectedCard(false);
      setIsUserProfileOpen(false);
      setIsClosed(false);
      return;
    }
    setSelectedCard(true);
    dispatch(setSelectedSupplier(supplier));
    setIsUserProfileOpen(true);
  };
  const handleSelectUserProfile = (event, supplier) => {
    handleCardSelection(supplier);
  };

  const toggleMenu = (supplierId) => {
    setMenuVisibility((prevState) => {
      const newVisibility = Object.keys(prevState).reduce((acc, id) => {
        acc[id] = false;
        return acc;
      }, {});

      return {
        ...newVisibility,
        [supplierId]: true,
      };
    });

    setDotsMenuOpen(!isDotsMenuOpen);
  };

  const handleEditClick = (company) => {
    handleEdit(company);
    toggleMenu(company._id);
  };
  const handleViewPending = () => {
    setCheckboxVisible(false);
    setMultipleMenuClicked(false);
    setPendingOpen(true);

    dispatch(fetchPendingSuppliers({ buyerId: userId }));
  };

  const handleViewAll = () => {
    setCheckboxVisible(false);
    setMultipleMenuClicked(false);
    setPendingOpen(false);
  };

  const itemsPerPage = 50;

  useEffect(() => {
    const buyerIdToUse = user?.isTestUser ? user?.id : userId;
    dispatch(
      getAllSuppliers({
        page: currentPage,
        limit: itemsPerPage,
        buyerId: buyerIdToUse,
      })
    );
    dispatch(getFolderCountsByBuyerId(buyerIdToUse));
  }, [currentPage, dispatch, isDeletetriggered]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const clearSearch = () => {
    setRecommendedSuppliersLoaded(false);
    setMoreSuppliersClicked(false);
    setFilteringDone(false);
    setSearchInProgress(false);
    setSearchTrigered(false);
    window.scrollTo(0, 0);
  };

  const handleClickOutside = (event) => {
    if (dotsMenuRef.current && !dotsMenuRef.current.contains(event.target)) {
      setDotsMenuOpen(false);
    }
    if (
      deleteWindowRef.current &&
      !deleteWindowRef.current.contains(event.target)
    ) {
      setDeletedSupplier(false);
    }
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dotsMenuRef]);

  const overlayStyle = {
    background: "rgba(0, 0, 0, 0.3)",
  };

  const divFlexRow = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  };

  const paginationBarStyle = {
    position: "absolute",
    width: "100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: "30px",
    marginBottom: "20px",
    marginTop: "40px",
    padding: "10px",
    background: "transparent",
    bottom: 0,
    boxShadow: "none",
  };

  const getGridCols = () => {
    if (isCheckboxVisible) {
      return !isPanelOpen
        ? "grid-cols-[60px_minmax(160px,2fr)_minmax(120px,1.5fr)_minmax(120px,1.5fr)_1fr_1fr_minmax(180px,1.8fr)_80px]"
        : "grid-cols-[60px_minmax(160px,2fr)_minmax(120px,1.5fr)_minmax(120px,1.5fr)_1fr_1fr_minmax(180px,1.8fr)_80px]";
    } else {
      return !isPanelOpen
        ? "grid-cols-[5px_minmax(160px,2fr)_minmax(120px,1.5fr)_minmax(120px,1.5fr)_1fr_1fr_minmax(180px,1.8fr)_80px]"
        : "grid-cols-[5px_minmax(160px,2fr)_minmax(120px,1.5fr)_minmax(120px,1.5fr)_1fr_1fr_minmax(180px,1.8fr)_80px]";
    }
  };

  return (
    <div
      className="mb-20 mt-10 mx-[10px]"
      style={{
        background: "#fff",
        borderRadius: "13px",
        border: "1px solid #EAECF0",
      }}
    >
      <div>
        <div>
          <div>
            <div className="filter-container">
              <div style={{ marginLeft: "31px", display: "flex" }}>
                <div style={{ position: "relative", display: "inline-block" }}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    style={{
                      position: "absolute",
                      left: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      pointerEvents: "none",
                    }}
                  >
                    <g clipPath="url(#clip0_180_58425)">
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M8.75021 1.66699C7.62071 1.66709 6.5076 1.9373 5.50376 2.45507C4.49992 2.97285 3.63446 3.72317 2.97957 4.64345C2.32469 5.56373 1.89939 6.62728 1.73913 7.74536C1.57888 8.86344 1.68834 10.0036 2.05836 11.0708C2.42838 12.138 3.04825 13.1012 3.86624 13.8801C4.68423 14.659 5.67663 15.231 6.76064 15.5483C7.84465 15.8657 8.98883 15.9192 10.0977 15.7044C11.2066 15.4896 12.2481 15.0128 13.1352 14.3137L16.1785 17.357C16.3357 17.5088 16.5462 17.5928 16.7647 17.5909C16.9832 17.589 17.1922 17.5013 17.3467 17.3468C17.5012 17.1923 17.5889 16.9833 17.5908 16.7648C17.5927 16.5463 17.5087 16.3358 17.3569 16.1787L14.3135 13.1353C15.1369 12.0908 15.6495 10.8357 15.7928 9.51343C15.9361 8.1912 15.7042 6.85534 15.1237 5.65874C14.5433 4.46213 13.6376 3.45312 12.5105 2.74718C11.3833 2.04125 10.0802 1.6669 8.75021 1.66699ZM3.33354 8.75033C3.33354 7.31374 3.90423 5.93599 4.92005 4.92016C5.93587 3.90434 7.31362 3.33366 8.75021 3.33366C10.1868 3.33366 11.5646 3.90434 12.5804 4.92016C13.5962 5.93599 14.1669 7.31374 14.1669 8.75033C14.1669 10.1869 13.5962 11.5647 12.5804 12.5805C11.5646 13.5963 10.1868 14.167 8.75021 14.167C7.31362 14.167 5.93587 13.5963 4.92005 12.5805C3.90423 11.5647 3.33354 10.1869 3.33354 8.75033Z"
                        fill="#7B7B7B"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_180_58425">
                        <rect width="20" height="20" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>

                  <input
                    type="text"
                    value={searchQuery}
                    placeholder="Input your prompt to match your search"
                    aria-label="Search"
                    className="supplier-search-input pl-[35px] text-[#A8A8A8] italic font-normal"
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                </div>

                <div className="flex flex-row gap-4">
                  <button
                    onClick={handleSearch}
                    type="submit"
                    className="flex items-center gap-2 px-4 py-2 text-white rounded-lg bg-[#08F] font-semibold ml-2 border-none cursor-pointer"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <g clipPath="url(#clip0_180_58425)">
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M8.75021 1.66699C7.62071 1.66709 6.5076 1.9373 5.50376 2.45507C4.49992 2.97285 3.63446 3.72317 2.97957 4.64345C2.32469 5.56373 1.89939 6.62728 1.73913 7.74536C1.57888 8.86344 1.68834 10.0036 2.05836 11.0708C2.42838 12.138 3.04825 13.1012 3.86624 13.8801C4.68423 14.659 5.67663 15.231 6.76064 15.5483C7.84465 15.8657 8.98883 15.9192 10.0977 15.7044C11.2066 15.4896 12.2481 15.0128 13.1352 14.3137L16.1785 17.357C16.3357 17.5088 16.5462 17.5928 16.7647 17.5909C16.9832 17.589 17.1922 17.5013 17.3467 17.3468C17.5012 17.1923 17.5889 16.9833 17.5908 16.7648C17.5927 16.5463 17.5087 16.3358 17.3569 16.1787L14.3135 13.1353C15.1369 12.0908 15.6495 10.8357 15.7928 9.51343C15.9361 8.1912 15.7042 6.85534 15.1237 5.65874C14.5433 4.46213 13.6376 3.45312 12.5105 2.74718C11.3833 2.04125 10.0802 1.6669 8.75021 1.66699ZM3.33354 8.75033C3.33354 7.31374 3.90423 5.93599 4.92005 4.92016C5.93587 3.90434 7.31362 3.33366 8.75021 3.33366C10.1868 3.33366 11.5646 3.90434 12.5804 4.92016C13.5962 5.93599 14.1669 7.31374 14.1669 8.75033C14.1669 10.1869 13.5962 11.5647 12.5804 12.5805C11.5646 13.5963 10.1868 14.167 8.75021 14.167C7.31362 14.167 5.93587 13.5963 4.92005 12.5805C3.90423 11.5647 3.33354 10.1869 3.33354 8.75033Z"
                          fill="#fff"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_180_58425">
                          <rect width="20" height="20" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                    Search
                  </button>
                  <PdfImportButton
                    management={true}
                    setImportCompleted={setImportCompleted}
                  />
                  <div className="">
                    <button
                      onClick={() => setShowFilters(!showFilters)}
                      className="inline-flex h-[42px] px-3 py-2 items-center gap-2 bg-[#F6F6F6] rounded-[8px] border text-sm text-[#1D2739]"
                    >
                      Filters
                    </button>

                    {showFilters && (
                      <>
                        <Overlay />
                        <div className="absolute flex items-center justify-center left-1/2 top-0 transform -translate-x-1/2 z-[1100]">
                          <div className="flex flex-col items-center justify-start px-[51px] pb-[34px] pt-0 w-[658px] h-[810px] rounded bg-white shadow-[0_0_10px_rgba(0,0,0,0.1)] mt-[5px] overflow-auto">
                            <span className="mt-16 mb-8 text-[#1D2739] text-lg text-left flex justify-start items-left font-semibold">
                              Filters
                            </span>

                            {/* Country */}
                            <div className="w-full mb-6">
                              <label className="block text-[#1D2639] text-base text-start font-normal">
                                Country
                              </label>
                              <Select
                                isMulti
                                options={countryOptions}
                                styles={customStyles}
                                value={selectedFilters.Country.map((c) => ({
                                  value: c,
                                  label: c,
                                }))}
                                onChange={(selected) =>
                                  handleSelectChange("Country", selected)
                                }
                              />
                            </div>

                            <div className="w-full mb-6">
                              <label className="block text-[#1D2639] text-base text-start font-normal">
                                State/Province
                              </label>
                              <Select
                                isMulti
                                styles={customStyles}
                                options={selectedFilters.Country.flatMap(
                                  (country) => stateOptions[country] || []
                                )}
                                value={selectedFilters.State.map((s) => ({
                                  value: s,
                                  label: s,
                                }))}
                                onChange={(selected) =>
                                  handleSelectChange("State", selected)
                                }
                              />
                            </div>

                            <div className="w-full mb-6">
                              <label
                                htmlFor="city"
                                className="block text-[#1D2639] text-base text-start font-normal"
                              >
                                City
                              </label>
                              <input
                                type="text"
                                id="city"
                                placeholder="Enter a city"
                                className="w-full h-12 px-4 bg-[#F9F9F9] border-2 border-gray-300 rounded-lg focus:outline-none"
                                value={cityInput}
                                onChange={(e) => setCityInput(e.target.value)}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    e.preventDefault();
                                    handleCitySubmit();
                                  }
                                }}
                              />

                              {selectedFilters.City.length > 0 && (
                                <div className="flex flex-wrap gap-2 mt-2">
                                  {selectedFilters.City.map((city, index) => (
                                    <div
                                      key={index}
                                      className="flex items-center gap-1 px-2 py-1 bg-gray-100 text-[#1D2639] rounded-sm text-sm"
                                    >
                                      {city}
                                      <button
                                        onClick={() => removeTag("City", city)}
                                        className="text-[#1D2639] ml-1"
                                      >
                                        &times;
                                      </button>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>

                            <div className="w-full mb-6">
                              <label className="block text-[#1D2639] text-base text-start font-normal">
                                Industry
                              </label>
                              {/* <Select
                                isMulti
                                styles={customStyles}
                                options={industryOptions}
                                value={selectedFilters.Industry.map((i) => ({
                                  value: i,
                                  label: i,
                                }))}
                                onChange={(selected) =>
                                  handleIndustryChange(selected)
                                }
                              /> */}
                              <Select
                                options={industries.map(({ code, name }) => ({
                                  value: code,
                                  label: name,
                                }))}
                                value={
                                  selectedFilters.Industry.name
                                    ? {
                                        value: selectedFilters.Industry.code,
                                        label: selectedFilters.Industry.name,
                                      }
                                    : ""
                                }
                                onChange={handleIndustryChange}
                                styles={customStyles}
                                placeholder="Select an Industry..."
                                isClearable
                                isSearchable
                              />
                            </div>
                            {isIndustrySelected && (
                              <div className="w-full mb-6">
                                <label className="block text-[#1D2639] text-base text-start font-normal">
                                  NAICS Codes{" "}
                                  <span className="text-red-500">*</span>
                                </label>
                                <Select
                                  options={naicsData.map(
                                    ({ value, label }) => ({
                                      value,
                                      label,
                                    })
                                  )}
                                  value={
                                    selectedFilters.NaicsCodes?.length
                                      ? selectedFilters.NaicsCodes.map(
                                          (naic) => ({
                                            value: naic.code,
                                            label: naic.name,
                                          })
                                        )
                                      : naicsData.filter((option) =>
                                          NaicsCodes.includes(option.value)
                                        )
                                  }
                                  onChange={handleAdditionalNaicsChange}
                                  styles={customMultiSelectStyles}
                                  isMulti
                                  placeholder="Select NAICS Codes..."
                                />
                              </div>
                            )}

                            <div className="w-full mb-6">
                              <label className="block text-[#1D2639] text-base text-start font-normal">
                                Certification
                              </label>
                              <Select
                                isMulti
                                styles={customStyles}
                                options={certificationOptions}
                                value={selectedFilters.Certification.map(
                                  (c) => ({
                                    value: c,
                                    label: c,
                                  })
                                )}
                                onChange={(selected) =>
                                  handleSelectChange("Certification", selected)
                                }
                              />
                            </div>

                            <button
                              className={`flex mt-10 w-[382px] h-[50px] max-h-[64px] px-[38px] py-[22px] justify-center items-center gap-[10px] shrink-0 rounded-[8px] ${
                                isIndustrySelected &&
                                selectedFilters.NAICS.length < 1
                                  ? "bg-gray-200"
                                  : "bg-[#EAF524]"
                              } text-black`}
                              onClick={handleFilters}
                              disabled={
                                isIndustrySelected &&
                                selectedFilters?.NAICS?.length < 1
                              }
                            >
                              Apply Filters
                            </button>
                            <span
                              className="text-[#7E7E7E] mt-2"
                              onClick={() => handleCancel()}
                            >
                              Cancel
                            </span>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
              <div>
                <div className=" justify-content-end">
                  <div className="flex gap-2">
                    <svg
                      onClick={() => handleMultipleMenu()}
                      className=" relative mr-14"
                      xmlns="http://www.w3.org/2000/svg"
                      width="17"
                      height="18"
                      viewBox="0 0 17 18"
                      fill="none"
                    >
                      <path
                        d="M8.09267 4.1951C8.51167 4.1951 8.85135 3.85542 8.85135 3.43642C8.85135 3.01741 8.51167 2.67773 8.09267 2.67773C7.67366 2.67773 7.33398 3.01741 7.33398 3.43642C7.33398 3.85542 7.67366 4.1951 8.09267 4.1951Z"
                        stroke="#1D2739"
                        stroke-width="1.51736"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M8.09267 9.75857C8.51167 9.75857 8.85135 9.4189 8.85135 8.99989C8.85135 8.58088 8.51167 8.24121 8.09267 8.24121C7.67366 8.24121 7.33398 8.58088 7.33398 8.99989C7.33398 9.4189 7.67366 9.75857 8.09267 9.75857Z"
                        stroke="#1D2739"
                        stroke-width="1.51736"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M8.09267 15.3221C8.51167 15.3221 8.85135 14.9824 8.85135 14.5634C8.85135 14.1444 8.51167 13.8047 8.09267 13.8047C7.67366 13.8047 7.33398 14.1444 7.33398 14.5634C7.33398 14.9824 7.67366 15.3221 8.09267 15.3221Z"
                        stroke="#1D2739"
                        stroke-width="1.51736"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                </div>
              </div>

              {isMultipleMenuClicked && (
                <div
                  className="dots-menu"
                  style={{
                    position: "absolute",
                    height: "173px",
                    marginTop: "35px",
                  }}
                >
                  <span onClick={() => setSelect(true)} style={divFlexRow}>
                    <svg
                      className="mr-2"
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        d="M14.0517 3.73937L15.4575 2.33271C15.7506 2.03964 16.148 1.875 16.5625 1.875C16.977 1.875 17.3744 2.03964 17.6675 2.33271C17.9606 2.62577 18.1252 3.02325 18.1252 3.43771C18.1252 3.85216 17.9606 4.24964 17.6675 4.54271L8.81833 13.3919C8.37777 13.8322 7.83447 14.1558 7.2375 14.3335L5 15.0002L5.66667 12.7627C5.8444 12.1657 6.16803 11.6224 6.60833 11.1819L14.0517 3.73937ZM14.0517 3.73937L16.25 5.93771M15 11.6669V15.6252C15 16.1225 14.8025 16.5994 14.4508 16.951C14.0992 17.3027 13.6223 17.5002 13.125 17.5002H4.375C3.87772 17.5002 3.40081 17.3027 3.04917 16.951C2.69754 16.5994 2.5 16.1225 2.5 15.6252V6.87521C2.5 6.37793 2.69754 5.90101 3.04917 5.54938C3.40081 5.19775 3.87772 5.00021 4.375 5.00021H8.33333"
                        stroke="#7B7B7B"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    Select
                  </span>
                  <span
                    onClick={() => handleSelectAllChange()}
                    style={divFlexRow}
                  >
                    <svg
                      className="mr-2"
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        d="M14.0517 3.73937L15.4575 2.33271C15.7506 2.03964 16.148 1.875 16.5625 1.875C16.977 1.875 17.3744 2.03964 17.6675 2.33271C17.9606 2.62577 18.1252 3.02325 18.1252 3.43771C18.1252 3.85216 17.9606 4.24964 17.6675 4.54271L8.81833 13.3919C8.37777 13.8322 7.83447 14.1558 7.2375 14.3335L5 15.0002L5.66667 12.7627C5.8444 12.1657 6.16803 11.6224 6.60833 11.1819L14.0517 3.73937ZM14.0517 3.73937L16.25 5.93771M15 11.6669V15.6252C15 16.1225 14.8025 16.5994 14.4508 16.951C14.0992 17.3027 13.6223 17.5002 13.125 17.5002H4.375C3.87772 17.5002 3.40081 17.3027 3.04917 16.951C2.69754 16.5994 2.5 16.1225 2.5 15.6252V6.87521C2.5 6.37793 2.69754 5.90101 3.04917 5.54938C3.40081 5.19775 3.87772 5.00021 4.375 5.00021H8.33333"
                        stroke="#7B7B7B"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    Select all
                  </span>
                  {isPendingOpen ? (
                    <span onClick={() => handleViewAll()} style={divFlexRow}>
                      <svg
                        className="mr-2"
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                          stroke="#7B7B7B"
                          stroke-width="2"
                        />
                        <path
                          d="M20.1885 10.934C20.5765 11.406 20.7705 11.641 20.7705 12C20.7705 12.359 20.5765 12.594 20.1885 13.066C18.7685 14.79 15.6365 18 12.0005 18C8.36447 18 5.23247 14.79 3.81247 13.066C3.42447 12.594 3.23047 12.359 3.23047 12C3.23047 11.641 3.42447 11.406 3.81247 10.934C5.23247 9.21 8.36447 6 12.0005 6C15.6365 6 18.7685 9.21 20.1885 10.934Z"
                          stroke="#7B7B7B"
                          stroke-width="2"
                        />
                      </svg>
                      View All
                    </span>
                  ) : (
                    <span
                      onClick={() => handleViewPending()}
                      style={divFlexRow}
                    >
                      <svg
                        className="mr-2"
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                          stroke="#7B7B7B"
                          stroke-width="2"
                        />
                        <path
                          d="M20.1885 10.934C20.5765 11.406 20.7705 11.641 20.7705 12C20.7705 12.359 20.5765 12.594 20.1885 13.066C18.7685 14.79 15.6365 18 12.0005 18C8.36447 18 5.23247 14.79 3.81247 13.066C3.42447 12.594 3.23047 12.359 3.23047 12C3.23047 11.641 3.42447 11.406 3.81247 10.934C5.23247 9.21 8.36447 6 12.0005 6C15.6365 6 18.7685 9.21 20.1885 10.934Z"
                          stroke="#7B7B7B"
                          stroke-width="2"
                        />
                      </svg>
                      View Pending
                    </span>
                  )}
                </div>
              )}

              {isSelectionMenuClicked && (
                <div
                  className="dots-menu"
                  style={{
                    position: "absolute",
                    height: "220px",
                    marginTop: "35px",
                  }}
                >
                  <span
                    onClick={() => handleClearSelection()}
                    style={divFlexRow}
                  >
                    <svg
                      className="mr-2"
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        d="M14.0517 3.73937L15.4575 2.33271C15.7506 2.03964 16.148 1.875 16.5625 1.875C16.977 1.875 17.3744 2.03964 17.6675 2.33271C17.9606 2.62577 18.1252 3.02325 18.1252 3.43771C18.1252 3.85216 17.9606 4.24964 17.6675 4.54271L8.81833 13.3919C8.37777 13.8322 7.83447 14.1558 7.2375 14.3335L5 15.0002L5.66667 12.7627C5.8444 12.1657 6.16803 11.6224 6.60833 11.1819L14.0517 3.73937ZM14.0517 3.73937L16.25 5.93771M15 11.6669V15.6252C15 16.1225 14.8025 16.5994 14.4508 16.951C14.0992 17.3027 13.6223 17.5002 13.125 17.5002H4.375C3.87772 17.5002 3.40081 17.3027 3.04917 16.951C2.69754 16.5994 2.5 16.1225 2.5 15.6252V6.87521C2.5 6.37793 2.69754 5.90101 3.04917 5.54938C3.40081 5.19775 3.87772 5.00021 4.375 5.00021H8.33333"
                        stroke="#7B7B7B"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    Clear Selection
                  </span>
                  <span
                    onClick={() => setIsBulkModalOpen(true)}
                    style={divFlexRow}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      className="mr-2"
                    >
                      <path
                        d="M7.25009 8C7.25009 8.19891 7.32911 8.38968 7.46976 8.53033C7.61041 8.67098 7.80118 8.75 8.00009 8.75C8.199 8.75 8.38977 8.67098 8.53042 8.53033C8.67107 8.38968 8.75009 8.19891 8.75009 8C8.75009 7.80109 8.67107 7.61032 8.53042 7.46967C8.38977 7.32902 8.199 7.25 8.00009 7.25C7.80118 7.25 7.61041 7.32902 7.46976 7.46967C7.32911 7.61032 7.25009 7.80109 7.25009 8ZM10.3751 8C10.3751 8.19891 10.4541 8.38968 10.5948 8.53033C10.7354 8.67098 10.9262 8.75 11.1251 8.75C11.324 8.75 11.5148 8.67098 11.6554 8.53033C11.7961 8.38968 11.8751 8.19891 11.8751 8C11.8751 7.80109 11.7961 7.61032 11.6554 7.46967C11.5148 7.32902 11.324 7.25 11.1251 7.25C10.9262 7.25 10.7354 7.32902 10.5948 7.46967C10.4541 7.61032 10.3751 7.80109 10.3751 8ZM4.12509 8C4.12509 8.19891 4.20411 8.38968 4.34476 8.53033C4.48541 8.67098 4.67618 8.75 4.87509 8.75C5.074 8.75 5.26477 8.67098 5.40542 8.53033C5.54607 8.38968 5.62509 8.19891 5.62509 8C5.62509 7.80109 5.54607 7.61032 5.40542 7.46967C5.26477 7.32902 5.074 7.25 4.87509 7.25C4.67618 7.25 4.48541 7.32902 4.34476 7.46967C4.20411 7.61032 4.12509 7.80109 4.12509 8ZM14.4563 5.2875C14.1032 4.44844 13.597 3.69531 12.9517 3.04844C12.3108 2.40532 11.5501 1.89411 10.7126 1.54375C9.85321 1.18281 8.94071 1 8.00009 1H7.96884C7.02196 1.00469 6.10478 1.19219 5.24228 1.56094C4.41191 1.91489 3.65833 2.42701 3.02353 3.06875C2.38446 3.71406 1.8829 4.46406 1.53603 5.3C1.17665 6.16563 0.995401 7.08594 1.00009 8.03281C1.00539 9.11792 1.26211 10.187 1.75009 11.1562V13.5312C1.75009 13.7219 1.82581 13.9047 1.96061 14.0395C2.0954 14.1743 2.27821 14.25 2.46884 14.25H4.8454C5.81461 14.738 6.88373 14.9947 7.96884 15H8.00165C8.93759 15 9.8454 14.8188 10.7001 14.4641C11.5334 14.1179 12.2913 13.6126 12.9313 12.9766C13.5767 12.3375 14.0845 11.5906 14.4392 10.7578C14.8079 9.89531 14.9954 8.97812 15.0001 8.03125C15.0048 7.07969 14.8204 6.15625 14.4563 5.2875ZM12.0954 12.1313C11.0001 13.2156 9.54696 13.8125 8.00009 13.8125H7.97353C7.03134 13.8078 6.0954 13.5734 5.26884 13.1328L5.13759 13.0625H2.93759V10.8625L2.86728 10.7312C2.42665 9.90469 2.19228 8.96875 2.18759 8.02656C2.18134 6.46875 2.77665 5.00625 3.86884 3.90469C4.95946 2.80312 6.41728 2.19375 7.97509 2.1875H8.00165C8.7829 2.1875 9.54071 2.33906 10.2548 2.63906C10.9517 2.93125 11.5767 3.35156 12.1142 3.88906C12.6501 4.425 13.072 5.05156 13.3642 5.74844C13.6673 6.47031 13.8188 7.23594 13.8157 8.02656C13.8063 9.58281 13.1954 11.0406 12.0954 12.1313Z"
                        fill="#7B7B7B"
                      />
                    </svg>
                    Bulk message
                  </span>
                  <span
                    onClick={() => handleSendInviteInBulk()}
                    style={divFlexRow}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      className="mr-2"
                    >
                      <g clip-path="url(#clip0_683_52776)">
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M11.3359 2C11.8461 1.99997 12.3369 2.19488 12.7081 2.54486C13.0793 2.89483 13.3027 3.3734 13.3326 3.88267L13.3359 4V6.9L13.7319 6.724C14.1413 6.542 14.6133 6.824 14.6653 7.256L14.6693 7.33333V12.6667C14.6694 13.0031 14.5423 13.327 14.3136 13.5737C14.0849 13.8204 13.7714 13.9714 13.4359 13.9967L13.3359 14H2.66927C2.33289 14.0001 2.00889 13.8731 1.76224 13.6443C1.51558 13.4156 1.3645 13.1021 1.33927 12.7667L1.33594 12.6667V7.33333C1.33594 6.88533 1.78594 6.56867 2.2006 6.69667L2.27394 6.724L2.66927 6.9V4C2.66924 3.48986 2.86415 2.99899 3.21413 2.62783C3.5641 2.25666 4.04268 2.03326 4.55194 2.00333L4.66927 2H11.3359ZM13.3359 8.35933L8.54394 10.4887C8.37351 10.5644 8.18909 10.6035 8.0026 10.6035C7.81611 10.6035 7.6317 10.5644 7.46127 10.4887L2.66927 8.36V12.6667H13.3359V8.35933ZM11.3359 3.33333H4.66927C4.49246 3.33333 4.32289 3.40357 4.19787 3.5286C4.07284 3.65362 4.0026 3.82319 4.0026 4V7.49267L8.0026 9.27067L12.0026 7.49267V4C12.0026 3.82319 11.9324 3.65362 11.8073 3.5286C11.6823 3.40357 11.5127 3.33333 11.3359 3.33333ZM8.0026 5.33333C8.17252 5.33352 8.33596 5.39859 8.45952 5.51523C8.58307 5.63188 8.65743 5.7913 8.66739 5.96093C8.67734 6.13056 8.62215 6.29759 8.51309 6.42789C8.40403 6.55819 8.24933 6.64193 8.0806 6.662L8.0026 6.66667H6.66927C6.49935 6.66648 6.33592 6.60141 6.21236 6.48477C6.0888 6.36812 6.01445 6.2087 6.00449 6.03907C5.99453 5.86944 6.04972 5.70241 6.15878 5.57211C6.26784 5.44181 6.42254 5.35807 6.59127 5.338L6.66927 5.33333H8.0026Z"
                          fill="#7B7B7B"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_683_52776">
                          <rect width="16" height="16" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                    Invite to SourceIQ
                  </span>
                  {/* <span
                    onClick={() => handleRequestInfo(selectedSuppliers)}
                    style={divFlexRow}
                  >
                    <svg
                      className="mr-2"
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        d="M14.0517 3.73937L15.4575 2.33271C15.7506 2.03964 16.148 1.875 16.5625 1.875C16.977 1.875 17.3744 2.03964 17.6675 2.33271C17.9606 2.62577 18.1252 3.02325 18.1252 3.43771C18.1252 3.85216 17.9606 4.24964 17.6675 4.54271L8.81833 13.3919C8.37777 13.8322 7.83447 14.1558 7.2375 14.3335L5 15.0002L5.66667 12.7627C5.8444 12.1657 6.16803 11.6224 6.60833 11.1819L14.0517 3.73937ZM14.0517 3.73937L16.25 5.93771M15 11.6669V15.6252C15 16.1225 14.8025 16.5994 14.4508 16.951C14.0992 17.3027 13.6223 17.5002 13.125 17.5002H4.375C3.87772 17.5002 3.40081 17.3027 3.04917 16.951C2.69754 16.5994 2.5 16.1225 2.5 15.6252V6.87521C2.5 6.37793 2.69754 5.90101 3.04917 5.54938C3.40081 5.19775 3.87772 5.00021 4.375 5.00021H8.33333"
                        stroke="#7B7B7B"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    Request info
                  </span> */}
                  <span
                    onClick={() => handleDeleteSelection()}
                    style={divFlexRow}
                  >
                    <svg
                      className="mr-2"
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        d="M14.0517 3.73937L15.4575 2.33271C15.7506 2.03964 16.148 1.875 16.5625 1.875C16.977 1.875 17.3744 2.03964 17.6675 2.33271C17.9606 2.62577 18.1252 3.02325 18.1252 3.43771C18.1252 3.85216 17.9606 4.24964 17.6675 4.54271L8.81833 13.3919C8.37777 13.8322 7.83447 14.1558 7.2375 14.3335L5 15.0002L5.66667 12.7627C5.8444 12.1657 6.16803 11.6224 6.60833 11.1819L14.0517 3.73937ZM14.0517 3.73937L16.25 5.93771M15 11.6669V15.6252C15 16.1225 14.8025 16.5994 14.4508 16.951C14.0992 17.3027 13.6223 17.5002 13.125 17.5002H4.375C3.87772 17.5002 3.40081 17.3027 3.04917 16.951C2.69754 16.5994 2.5 16.1225 2.5 15.6252V6.87521C2.5 6.37793 2.69754 5.90101 3.04917 5.54938C3.40081 5.19775 3.87772 5.00021 4.375 5.00021H8.33333"
                        stroke="#7B7B7B"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    Delete selection
                  </span>
                </div>
              )}
            </div>
            {(isRecommendedSuppliersLoaded ||
              isSearchInProgress ||
              isFilteringDone) && (
              <div className="flex flex-row justify-between">
                <span className="recommended-supplier-title">
                  {isFilteringDone
                    ? "Filtered Suppliers"
                    : "Top recommended suppliers"}
                </span>
                <button
                  className="text-[#7B7B7B] font-[19px] mr-10 flex flex-row justify-center items-center"
                  onClick={clearSearch}
                >
                  <svg
                    className="ml-1"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                  >
                    <path
                      d="M11.9998 13.9L7.0998 18.8C6.91647 18.9834 6.68314 19.0751 6.3998 19.0751C6.11647 19.0751 5.88314 18.9834 5.6998 18.8C5.51647 18.6167 5.4248 18.3834 5.4248 18.1001C5.4248 17.8167 5.51647 17.5834 5.6998 17.4L10.5998 12.5L5.6998 7.60005C5.51647 7.41672 5.4248 7.18338 5.4248 6.90005C5.4248 6.61672 5.51647 6.38338 5.6998 6.20005C5.88314 6.01672 6.11647 5.92505 6.3998 5.92505C6.68314 5.92505 6.91647 6.01672 7.0998 6.20005L11.9998 11.1L16.8998 6.20005C17.0831 6.01672 17.3165 5.92505 17.5998 5.92505C17.8831 5.92505 18.1165 6.01672 18.2998 6.20005C18.4831 6.38338 18.5748 6.61672 18.5748 6.90005C18.5748 7.18338 18.4831 7.41672 18.2998 7.60005L13.3998 12.5L18.2998 17.4C18.4831 17.5834 18.5748 17.8167 18.5748 18.1001C18.5748 18.3834 18.4831 18.6167 18.2998 18.8C18.1165 18.9834 17.8831 19.0751 17.5998 19.0751C17.3165 19.0751 17.0831 18.9834 16.8998 18.8L11.9998 13.9Z"
                      fill="#7B7B7B"
                    />
                  </svg>
                  Clear search
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      <div class="w-full">
        <div
          className={`grid ${getGridCols()}  bg-gray-100 py-4 text-start text-[13px] text-[#757575] whitespace-nowrap`}
        >
          <div class="px-4"></div>
          <div class="px-4">Supplier</div>
          <div class="px-4">Website</div>
          <div class="px-4">Industry</div>
          <div class="px-4">Company Size</div>
          <div class="px-4">Certification</div>
          <div class="px-4">Diversity Status</div>
          <div class="px-4">Action</div>
        </div>

        <div class="divide-y divide-gray-200">
          {(isSavedSuppliers
            ? savedSuppliers
            : isRecommendedSuppliersLoaded
            ? isSearchInProgress
              ? searchSuppliersData
              : recommendedSuppliers
            : isPendingOpen
            ? pendingSuppliers
            : isFiltered && selectedFolderName !== "Total Suppliers"
            ? suppliersByFolder
            : isFilteringDone
            ? filteredSuppliers
            : allSuppliers
          ).map((company) => (
            <div
              key={company.company._id}
              className={`grid ${getGridCols()} py-4 text-start text-[13px] text-[#757575]`}
            >
              <div className="px-4 flex justify-start items-start">
                {isCheckboxVisible && (
                  <input
                    type="checkbox"
                    onChange={() => handleSelectMenuClick(company)}
                    className="accent-[#08F] rounded shadow-lg shadow-gray-500 cursor-pointer transition-all duration-150 hover:shadow-xl mt-1"
                    checked={selectedSuppliers.some(
                      (supplier) => supplier._id === company._id
                    )}
                  />
                )}
              </div>

              <div
                className="px-4 text-[13px] text-[#1D2739] font-semibold"
                onClick={(e) => {
                  if (!isCheckboxVisible) {
                    handleSelectUserProfile(e, company);
                  }
                }}
              >
                {company?.company?.name}
              </div>
              <div className="px-4 text-[13px] text-[#1D2739] truncate max-w-[200px]">
                {company?.company?.website}
              </div>
              <div className="px-4 text-[13px] text-[#1D2739] ">
                {company?.industry?.name ? (
                  company.industry.name
                ) : (
                  <span className="text-gray-400">Pending</span>
                )}
              </div>
              <div className="px-4 text-[13px] text-[#1D2739] ">
                {
                  /* {company?.company?.businessSize?.min &&
                company?.company?.businessSize?.max  */
                  company.company.businessSize.value ? (
                    company.company.businessSize.value
                  ) : (
                    <span className="text-gray-400">Pending</span>
                  )
                }
              </div>
              <div className="px-4 text-[13px] text-[#1D2739] ">
                {company?.diversity?.certificationType[0]?.type || (
                  <span class="text-gray-400">Pending</span>
                )}
              </div>
              <div className="px-4">
                <div className="bg-[#E8E8E8] rounded px-2 py-1 text-[13px] text-[#1D2739] inline-block">
                  {company?.diversity?.certificationType[0]?.classification || (
                    <span class="text-gray-400">Pending</span>
                  )}
                </div>
              </div>
              <div className="px-4 cursor-pointer">
                <div
                  className="px-4 cursor-pointer"
                  onClick={() => toggleMenu(company._id)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="17"
                    height="18"
                    viewBox="0 0 17 18"
                    fill="none"
                  >
                    <path
                      d="M8.09267 4.1951C8.51167 4.1951 8.85135 3.85542 8.85135 3.43642C8.85135 3.01741 8.51167 2.67773 8.09267 2.67773C7.67366 2.67773 7.33398 3.01741 7.33398 3.43642C7.33398 3.85542 7.67366 4.1951 8.09267 4.1951Z"
                      stroke="#1D2739"
                      stroke-width="1.51736"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M8.09267 9.75857C8.51167 9.75857 8.85135 9.4189 8.85135 8.99989C8.85135 8.58088 8.51167 8.24121 8.09267 8.24121C7.67366 8.24121 7.33398 8.58088 7.33398 8.99989C7.33398 9.4189 7.67366 9.75857 8.09267 9.75857Z"
                      stroke="#1D2739"
                      stroke-width="1.51736"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M8.09267 15.3221C8.51167 15.3221 8.85135 14.9824 8.85135 14.5634C8.85135 14.1444 8.51167 13.8047 8.09267 13.8047C7.67366 13.8047 7.33398 14.1444 7.33398 14.5634C7.33398 14.9824 7.67366 15.3221 8.09267 15.3221Z"
                      stroke="#1D2739"
                      stroke-width="1.51736"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  {menuVisibility[company._id] && isDotsMenuOpen && (
                    <div
                      className="dots-menu"
                      style={{
                        position: "absolute",
                        height: isSavedSuppliers ? "180px" : "290px",
                      }}
                    >
                      <span
                        onClick={() => handleSendMessage(company)}
                        style={divFlexRow}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          className="mr-2"
                        >
                          <path
                            d="M7.25009 8C7.25009 8.19891 7.32911 8.38968 7.46976 8.53033C7.61041 8.67098 7.80118 8.75 8.00009 8.75C8.199 8.75 8.38977 8.67098 8.53042 8.53033C8.67107 8.38968 8.75009 8.19891 8.75009 8C8.75009 7.80109 8.67107 7.61032 8.53042 7.46967C8.38977 7.32902 8.199 7.25 8.00009 7.25C7.80118 7.25 7.61041 7.32902 7.46976 7.46967C7.32911 7.61032 7.25009 7.80109 7.25009 8ZM10.3751 8C10.3751 8.19891 10.4541 8.38968 10.5948 8.53033C10.7354 8.67098 10.9262 8.75 11.1251 8.75C11.324 8.75 11.5148 8.67098 11.6554 8.53033C11.7961 8.38968 11.8751 8.19891 11.8751 8C11.8751 7.80109 11.7961 7.61032 11.6554 7.46967C11.5148 7.32902 11.324 7.25 11.1251 7.25C10.9262 7.25 10.7354 7.32902 10.5948 7.46967C10.4541 7.61032 10.3751 7.80109 10.3751 8ZM4.12509 8C4.12509 8.19891 4.20411 8.38968 4.34476 8.53033C4.48541 8.67098 4.67618 8.75 4.87509 8.75C5.074 8.75 5.26477 8.67098 5.40542 8.53033C5.54607 8.38968 5.62509 8.19891 5.62509 8C5.62509 7.80109 5.54607 7.61032 5.40542 7.46967C5.26477 7.32902 5.074 7.25 4.87509 7.25C4.67618 7.25 4.48541 7.32902 4.34476 7.46967C4.20411 7.61032 4.12509 7.80109 4.12509 8ZM14.4563 5.2875C14.1032 4.44844 13.597 3.69531 12.9517 3.04844C12.3108 2.40532 11.5501 1.89411 10.7126 1.54375C9.85321 1.18281 8.94071 1 8.00009 1H7.96884C7.02196 1.00469 6.10478 1.19219 5.24228 1.56094C4.41191 1.91489 3.65833 2.42701 3.02353 3.06875C2.38446 3.71406 1.8829 4.46406 1.53603 5.3C1.17665 6.16563 0.995401 7.08594 1.00009 8.03281C1.00539 9.11792 1.26211 10.187 1.75009 11.1562V13.5312C1.75009 13.7219 1.82581 13.9047 1.96061 14.0395C2.0954 14.1743 2.27821 14.25 2.46884 14.25H4.8454C5.81461 14.738 6.88373 14.9947 7.96884 15H8.00165C8.93759 15 9.8454 14.8188 10.7001 14.4641C11.5334 14.1179 12.2913 13.6126 12.9313 12.9766C13.5767 12.3375 14.0845 11.5906 14.4392 10.7578C14.8079 9.89531 14.9954 8.97812 15.0001 8.03125C15.0048 7.07969 14.8204 6.15625 14.4563 5.2875ZM12.0954 12.1313C11.0001 13.2156 9.54696 13.8125 8.00009 13.8125H7.97353C7.03134 13.8078 6.0954 13.5734 5.26884 13.1328L5.13759 13.0625H2.93759V10.8625L2.86728 10.7312C2.42665 9.90469 2.19228 8.96875 2.18759 8.02656C2.18134 6.46875 2.77665 5.00625 3.86884 3.90469C4.95946 2.80312 6.41728 2.19375 7.97509 2.1875H8.00165C8.7829 2.1875 9.54071 2.33906 10.2548 2.63906C10.9517 2.93125 11.5767 3.35156 12.1142 3.88906C12.6501 4.425 13.072 5.05156 13.3642 5.74844C13.6673 6.47031 13.8188 7.23594 13.8157 8.02656C13.8063 9.58281 13.1954 11.0406 12.0954 12.1313Z"
                            fill="#7B7B7B"
                          />
                        </svg>
                        Send a message
                      </span>
                      {isSavedSuppliers ? null : (
                        <span
                          onClick={() => handleEditClick(company)}
                          style={divFlexRow}
                        >
                          <svg
                            className="mr-2"
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                          >
                            <path
                              d="M14.0517 3.73937L15.4575 2.33271C15.7506 2.03964 16.148 1.875 16.5625 1.875C16.977 1.875 17.3744 2.03964 17.6675 2.33271C17.9606 2.62577 18.1252 3.02325 18.1252 3.43771C18.1252 3.85216 17.9606 4.24964 17.6675 4.54271L8.81833 13.3919C8.37777 13.8322 7.83447 14.1558 7.2375 14.3335L5 15.0002L5.66667 12.7627C5.8444 12.1657 6.16803 11.6224 6.60833 11.1819L14.0517 3.73937ZM14.0517 3.73937L16.25 5.93771M15 11.6669V15.6252C15 16.1225 14.8025 16.5994 14.4508 16.951C14.0992 17.3027 13.6223 17.5002 13.125 17.5002H4.375C3.87772 17.5002 3.40081 17.3027 3.04917 16.951C2.69754 16.5994 2.5 16.1225 2.5 15.6252V6.87521C2.5 6.37793 2.69754 5.90101 3.04917 5.54938C3.40081 5.19775 3.87772 5.00021 4.375 5.00021H8.33333"
                              stroke="#7B7B7B"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          Edit Profile
                        </span>
                      )}
                      {isSavedSuppliers ? null : (
                        <span
                          style={divFlexRow}
                          onClick={() => {
                            setSelectedCompany(company);
                            setMoveToFolderActive(true);
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            className="mr-2"
                          >
                            <path
                              d="M0.664062 1.66602H6.3174L7.65073 3.33268H15.3307V13.9993H0.664062V1.66602ZM1.9974 2.99935V12.666H13.9974V4.66602H7.01073L5.6774 2.99935H1.9974Z"
                              fill="#7B7B7B"
                            />
                            <path
                              d="M5.33594 7.99931H8.4406L7.46327 6.97931L8.4266 6.05664L10.9259 8.66597L8.42594 11.2753L7.46327 10.3526L8.4406 9.33331H5.33594V7.99931Z"
                              fill="#7B7B7B"
                            />
                          </svg>
                          Move to folder
                        </span>
                      )}
                      <span
                        onClick={() => handleSendInvite(company)}
                        style={divFlexRow}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          className="mr-2"
                        >
                          <g clip-path="url(#clip0_683_52776)">
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M11.3359 2C11.8461 1.99997 12.3369 2.19488 12.7081 2.54486C13.0793 2.89483 13.3027 3.3734 13.3326 3.88267L13.3359 4V6.9L13.7319 6.724C14.1413 6.542 14.6133 6.824 14.6653 7.256L14.6693 7.33333V12.6667C14.6694 13.0031 14.5423 13.327 14.3136 13.5737C14.0849 13.8204 13.7714 13.9714 13.4359 13.9967L13.3359 14H2.66927C2.33289 14.0001 2.00889 13.8731 1.76224 13.6443C1.51558 13.4156 1.3645 13.1021 1.33927 12.7667L1.33594 12.6667V7.33333C1.33594 6.88533 1.78594 6.56867 2.2006 6.69667L2.27394 6.724L2.66927 6.9V4C2.66924 3.48986 2.86415 2.99899 3.21413 2.62783C3.5641 2.25666 4.04268 2.03326 4.55194 2.00333L4.66927 2H11.3359ZM13.3359 8.35933L8.54394 10.4887C8.37351 10.5644 8.18909 10.6035 8.0026 10.6035C7.81611 10.6035 7.6317 10.5644 7.46127 10.4887L2.66927 8.36V12.6667H13.3359V8.35933ZM11.3359 3.33333H4.66927C4.49246 3.33333 4.32289 3.40357 4.19787 3.5286C4.07284 3.65362 4.0026 3.82319 4.0026 4V7.49267L8.0026 9.27067L12.0026 7.49267V4C12.0026 3.82319 11.9324 3.65362 11.8073 3.5286C11.6823 3.40357 11.5127 3.33333 11.3359 3.33333ZM8.0026 5.33333C8.17252 5.33352 8.33596 5.39859 8.45952 5.51523C8.58307 5.63188 8.65743 5.7913 8.66739 5.96093C8.67734 6.13056 8.62215 6.29759 8.51309 6.42789C8.40403 6.55819 8.24933 6.64193 8.0806 6.662L8.0026 6.66667H6.66927C6.49935 6.66648 6.33592 6.60141 6.21236 6.48477C6.0888 6.36812 6.01445 6.2087 6.00449 6.03907C5.99453 5.86944 6.04972 5.70241 6.15878 5.57211C6.26784 5.44181 6.42254 5.35807 6.59127 5.338L6.66927 5.33333H8.0026Z"
                              fill="#7B7B7B"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_683_52776">
                              <rect width="16" height="16" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                        Invite to SourceIQ
                      </span>
                      <span
                        style={divFlexRow}
                        onClick={() => handleDeleteClick(company)}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="18"
                          viewBox="0 0 16 18"
                          fill="none"
                          className="mr-2"
                        >
                          <path
                            d="M10.2833 6.50043L9.995 14.0004M6.005 14.0004L5.71667 6.50043M14.0233 3.82543C14.3083 3.86877 14.5917 3.9146 14.875 3.96377M14.0233 3.82543L13.1333 15.3946C13.097 15.8656 12.8842 16.3056 12.5375 16.6265C12.1908 16.9474 11.7358 17.1256 11.2633 17.1254H4.73667C4.26425 17.1256 3.80919 16.9474 3.46248 16.6265C3.11578 16.3056 2.90299 15.8656 2.86667 15.3946L1.97667 3.82543M14.0233 3.82543C13.0616 3.68003 12.0948 3.56968 11.125 3.4946M1.97667 3.82543C1.69167 3.86793 1.40833 3.91377 1.125 3.96293M1.97667 3.82543C2.93844 3.68003 3.9052 3.56968 4.875 3.4946M11.125 3.4946V2.73127C11.125 1.74793 10.3667 0.927934 9.38333 0.897101C8.46135 0.867633 7.53865 0.867633 6.61667 0.897101C5.63333 0.927934 4.875 1.74877 4.875 2.73127V3.4946M11.125 3.4946C9.04477 3.33383 6.95523 3.33383 4.875 3.4946"
                            stroke="#7B7B7B"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        Delete Supplier
                      </span>
                    </div>
                  )}
                </div>
              </div>

              {showConfirmation && (
                <>
                  <Overlay overlayStyle={overlayStyle} />
                  <div
                    className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex items-center justify-center p-8"
                    style={{ zIndex: "10000" }}
                  >
                    <div className="flex flex-col justify-center gap-2 rounded-lg bg-white p-[20px_32px_20px_20px] w-[521px] h-[242px] mb-5 ml-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="24"
                        viewBox="0 0 22 24"
                        fill="none"
                      >
                        <path
                          d="M14.0825 8.62461L13.6933 18.7496M8.30675 18.7496L7.9175 8.62461M19.1315 5.01336C19.5163 5.07186 19.8987 5.13374 20.2812 5.20011M19.1315 5.01336L17.93 20.6317C17.881 21.2676 17.5937 21.8616 17.1256 22.2948C16.6576 22.728 16.0433 22.9686 15.4055 22.9684H6.5945C5.95673 22.9686 5.3424 22.728 4.87435 22.2948C4.4063 21.8616 4.11904 21.2676 4.07 20.6317L2.8685 5.01336M19.1315 5.01336C17.8331 4.81707 16.528 4.66809 15.2188 4.56674M2.8685 5.01336C2.48375 5.07074 2.10125 5.13261 1.71875 5.19899M2.8685 5.01336C4.1669 4.81707 5.47201 4.6681 6.78125 4.56674M15.2188 4.56674V3.53624C15.2188 2.20874 14.195 1.10173 12.8675 1.06011C11.6228 1.02033 10.3772 1.02033 9.1325 1.06011C7.805 1.10173 6.78125 2.20986 6.78125 3.53624V4.56674M15.2188 4.56674C12.4104 4.3497 9.58956 4.3497 6.78125 4.56674"
                          stroke="#FF0000"
                          stroke-width="1.875"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      <p className="text-base font-bold text-left">
                        {isSavedSuppliers
                          ? "Are you sure you want to remove this supplier from your Saved Suppliers list?"
                          : "Are you sure you want to delete this supplier profile?"}
                      </p>
                      <p style={{ color: "#7B7B7B", textAlign: "left" }}>
                        {isSavedSuppliers
                          ? ""
                          : "Deleted profiles can not be recovered and you will have to create them again"}
                      </p>
                      <div
                        style={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <button
                          onClick={handleCancelDelete}
                          className="flex w-[92px] p-[8px_16px] justify-center items-center gap-[8px] mt-5 mr-2 bg-[#F1F1F1] rounded-md"
                        >
                          Cancel
                        </button>
                        <button
                          className="flex w-[92px] p-[8px_16px] justify-center items-center gap-[8px] mt-5 mr-2 bg-[#FF0004] text-white rounded-md"
                          onClick={() => handleConfirmDelete(company)}
                        >
                          Yes
                        </button>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          ))}

          {showRequestConfirmation && selectedCompany && (
            <Dialog
              open={true}
              onClose={handleCancelRequest}
              className="relative"
              style={{ zIndex: "10000" }}
            >
              <div className="fixed inset-0 bg-black/30" />
              <div className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white p-6 rounded-lg w-[521px]">
                <p className="text-black text-base font-bold text-left mb-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="19"
                    height="19"
                    viewBox="0 0 19 19"
                    fill="none"
                    className="mb-4"
                  >
                    <path
                      d="M8.28231 10.7171L1 6.86224C6.29151 3.95488 12.0406 1.97232 17.9994 1C17.0277 6.9589 15.0458 12.7082 12.139 18L8.28231 10.7171ZM8.28231 10.7171L12.9887 6.0107"
                      stroke="#0088FF"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </p>
                <textarea
                  className="w-full h-[86px] p-4 rounded-md border border-[#D7D7D7] bg-[#F6F6F6]"
                  value={inviteMessage}
                  onChange={(e) => setInviteMessage(e.target.value)}
                />
                <div className="flex justify-end gap-2 mt-4">
                  <button
                    onClick={handleCancelRequest}
                    className="px-4 py-2 bg-[#F1F1F1] rounded-md"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={() =>
                      handleRequestConfirmation(selectedCompany._id)
                    }
                    className="px-4 py-2 bg-[#EAF524] rounded-md"
                  >
                    Send
                  </button>
                </div>
              </div>
            </Dialog>
          )}
        </div>

        {isDeletedSupplier && (
          <Dialog
            open={isDeletedSupplier}
            onClose={handleDone}
            className="relative"
            style={{ zIndex: "10000" }}
          >
            <div className="fixed inset-0 bg-black/40" aria-hidden="true" />

            <div className="fixed inset-0 flex items-center justify-center">
              <Dialog.Panel className="supplier-created-container bg-white p-6 rounded-lg shadow-lg text-center max-w-2xl mx-auto">
                <svg
                  className="mb-6 mx-auto"
                  xmlns="http://www.w3.org/2000/svg"
                  width="42"
                  height="42"
                  viewBox="0 0 42 42"
                  fill="none"
                >
                  <path
                    d="M21 0C26.5695 0 31.911 2.21249 35.8492 6.15076C39.7875 10.089 42 15.4305 42 21C42 26.5695 39.7875 31.911 35.8492 35.8492C31.911 39.7875 26.5695 42 21 42C15.4305 42 10.089 39.7875 6.15076 35.8492C2.21249 31.911 0 26.5695 0 21C0 15.4305 2.21249 10.089 6.15076 6.15076C10.089 2.21249 15.4305 0 21 0ZM18.384 25.143L13.719 20.475C13.5518 20.3078 13.3532 20.1751 13.1347 20.0846C12.9162 19.9941 12.682 19.9475 12.4455 19.9475C12.209 19.9475 11.9748 19.9941 11.7563 20.0846C11.5378 20.1751 11.3392 20.3078 11.172 20.475C10.8342 20.8128 10.6445 21.2708 10.6445 21.7485C10.6445 22.2262 10.8342 22.6842 11.172 23.022L17.112 28.962C17.2788 29.1301 17.4772 29.2635 17.6957 29.3545C17.9143 29.4456 18.1487 29.4924 18.3855 29.4924C18.6223 29.4924 18.8567 29.4456 19.0753 29.3545C19.2938 29.2635 19.4922 29.1301 19.659 28.962L31.959 16.659C32.1285 16.4925 32.2633 16.294 32.3557 16.0751C32.4481 15.8562 32.4962 15.6211 32.4973 15.3835C32.4984 15.1459 32.4525 14.9105 32.3621 14.6907C32.2718 14.4709 32.1388 14.2712 31.9709 14.1031C31.803 13.935 31.6034 13.8018 31.3838 13.7112C31.1641 13.6206 30.9287 13.5744 30.6911 13.5752C30.4535 13.576 30.2184 13.6239 29.9994 13.716C29.7804 13.8081 29.5817 13.9427 29.415 14.112L18.384 25.143Z"
                    fill="#0088FF"
                  />
                </svg>

                <Dialog.Title as="h3" className="mb-4 font-semibold text-lg">
                  Supplier profile deleted
                </Dialog.Title>

                <button
                  onClick={handleDone}
                  className="done-btn bg-[#EAF524] px-6 py-2 rounded font-semibold hover:bg-[#d4e100] transition"
                >
                  Done
                </button>
              </Dialog.Panel>
            </div>
          </Dialog>
        )}

        <Dialog
          open={isModalOpen}
          onClose={handleCloseModal}
          className="relative"
          style={{ zIndex: 10000 }}
        >
          <div className="fixed inset-0 bg-black/40" aria-hidden="true" />

          <div className="fixed inset-0 flex items-center justify-center">
            <Dialog.Panel className="bg-white p-6 rounded-lg shadow-lg w-[600px]">
              {isSuccess ? (
                <>
                  <Dialog.Title
                    as="h2"
                    className="text-base font-semibold mb-4 text-center flex justify-center items-center flex-col gap-6 py-16 px-12"
                  >
                    <div className="inline-flex items-center justify-center bg-[#D1D1D1] rounded mr-4 p-3 w-12">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="22"
                        viewBox="0 0 22 22"
                        fill="none"
                      >
                        <path
                          d="M19.5898 7.38075C19.1223 6.26518 18.4423 5.25121 17.5877 4.39533C16.7356 3.53798 15.7234 2.85633 14.6085 2.38908C13.4665 1.9081 12.2394 1.66155 11.0002 1.66408H10.9585C9.6981 1.67033 8.47935 1.92033 7.33143 2.412C6.22617 2.88404 5.22346 3.5669 4.37935 4.42241C3.53296 5.27636 2.86075 6.28679 2.40018 7.39741C1.9221 8.55234 1.67984 9.79122 1.68768 11.0412C1.69393 12.487 2.03977 13.9224 2.6856 15.2057V18.3724C2.6856 18.9016 3.11477 19.3307 3.64185 19.3307H6.80435C8.09367 19.9814 9.51645 20.3237 10.9606 20.3307H11.0044C12.2502 20.3307 13.4564 20.0891 14.5939 19.6162C15.7031 19.1545 16.7116 18.4808 17.5627 17.6328C18.421 16.7807 19.096 15.7849 19.5689 14.6745C20.0585 13.5245 20.3085 12.3016 20.3148 11.0391C20.3189 9.77033 20.0731 8.53908 19.5898 7.38075ZM6.84185 11.9974C6.29185 11.9974 5.84393 11.5495 5.84393 10.9974C5.84393 10.4453 6.29185 9.99741 6.84185 9.99741C7.39185 9.99741 7.83977 10.4453 7.83977 10.9974C7.83977 11.5495 7.39393 11.9974 6.84185 11.9974ZM11.0002 11.9974C10.4502 11.9974 10.0023 11.5495 10.0023 10.9974C10.0023 10.4453 10.4502 9.99741 11.0002 9.99741C11.5502 9.99741 11.9981 10.4453 11.9981 10.9974C11.9981 11.5495 11.5502 11.9974 11.0002 11.9974ZM15.1585 11.9974C14.6085 11.9974 14.1606 11.5495 14.1606 10.9974C14.1606 10.4453 14.6085 9.99741 15.1585 9.99741C15.7085 9.99741 16.1564 10.4453 16.1564 10.9974C16.1564 11.5495 15.7085 11.9974 15.1585 11.9974Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    Message sent successfully to supplier(s).
                  </Dialog.Title>
                  <div className="flex justify-center">
                    <button
                      onClick={handleCloseSuccess}
                      className="px-6 py-2 bg-[#EAF524] text-black font-medium rounded"
                    >
                      OK
                    </button>
                  </div>
                </>
              ) : (
                <>
                  <Dialog.Title
                    as="h2"
                    className="text-2xl font-semibold mb-4 flex flex-row justify-start items-center"
                  >
                    <div className="rounded bg-[#D1D1D1] p-3 mr-4">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="22"
                        viewBox="0 0 22 22"
                        fill="none"
                      >
                        <path
                          d="M19.5898 7.38075C19.1223 6.26518 18.4423 5.25121 17.5877 4.39533C16.7356 3.53798 15.7234 2.85633 14.6085 2.38908C13.4665 1.9081 12.2394 1.66155 11.0002 1.66408H10.9585C9.6981 1.67033 8.47935 1.92033 7.33143 2.412C6.22617 2.88404 5.22346 3.5669 4.37935 4.42241C3.53296 5.27636 2.86075 6.28679 2.40018 7.39741C1.9221 8.55234 1.67984 9.79122 1.68768 11.0412C1.69393 12.487 2.03977 13.9224 2.6856 15.2057V18.3724C2.6856 18.9016 3.11477 19.3307 3.64185 19.3307H6.80435C8.09367 19.9814 9.51645 20.3237 10.9606 20.3307H11.0044C12.2502 20.3307 13.4564 20.0891 14.5939 19.6162C15.7031 19.1545 16.7116 18.4808 17.5627 17.6328C18.421 16.7807 19.096 15.7849 19.5689 14.6745C20.0585 13.5245 20.3085 12.3016 20.3148 11.0391C20.3189 9.77033 20.0731 8.53908 19.5898 7.38075ZM6.84185 11.9974C6.29185 11.9974 5.84393 11.5495 5.84393 10.9974C5.84393 10.4453 6.29185 9.99741 6.84185 9.99741C7.39185 9.99741 7.83977 10.4453 7.83977 10.9974C7.83977 11.5495 7.39393 11.9974 6.84185 11.9974ZM11.0002 11.9974C10.4502 11.9974 10.0023 11.5495 10.0023 10.9974C10.0023 10.4453 10.4502 9.99741 11.0002 9.99741C11.5502 9.99741 11.9981 10.4453 11.9981 10.9974C11.9981 11.5495 11.5502 11.9974 11.0002 11.9974ZM15.1585 11.9974C14.6085 11.9974 14.1606 11.5495 14.1606 10.9974C14.1606 10.4453 14.6085 9.99741 15.1585 9.99741C15.7085 9.99741 16.1564 10.4453 16.1564 10.9974C16.1564 11.5495 15.7085 11.9974 15.1585 11.9974Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    Send a Message
                  </Dialog.Title>
                  {!selectedCompany?.misc?.isRegistrationCompleted && (
                    <span className="text-left text-[#EB1004]">
                      This supplier is not registered on the platform. Your
                      message will be sent to the email address we have on file.
                    </span>
                  )}

                  <div className="mb-3 mt-6">
                    <label className="text-sm font-medium text-gray-600">
                      Send to
                    </label>
                    <input
                      type="text"
                      className="w-full border rounded px-3 py-2 mt-1 bg-[#F4F4F4]"
                      value={selectedCompany?.company.name || ""}
                      disabled
                    />
                  </div>

                  <div className="mb-4">
                    <label className="text-sm font-medium text-gray-600">
                      Message
                    </label>
                    <textarea
                      className="w-full bg-[#F4F4F4] rounded px-3 py-2 mt-1"
                      rows={4}
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                    />
                  </div>

                  <div className="flex justify-end gap-3">
                    <button
                      onClick={handleCloseModal}
                      className="px-4 py-2 bg-[#F1F1F1] rounded "
                    >
                      Cancel
                    </button>
                    <button
                      onClick={handleSend}
                      className="px-4 py-2 bg-[#EAF524] text-black font-medium rounded"
                    >
                      Send
                    </button>
                  </div>
                </>
              )}
            </Dialog.Panel>
          </div>
        </Dialog>

        <Dialog
          open={isBulkModalOpen}
          onClose={handleBulkCloseModal}
          className="relative"
          style={{ zIndex: 10000 }}
        >
          <div className="fixed inset-0 bg-black/40" aria-hidden="true" />

          <div className="fixed inset-0 flex items-center justify-center">
            <Dialog.Panel className="bg-white p-6 rounded-lg shadow-lg w-[600px]">
              {isSuccess ? (
                <>
                  <Dialog.Title
                    as="h2"
                    className="text-base font-semibold mb-4 text-center flex justify-center items-center flex-col gap-6 py-16 px-12"
                  >
                    <div className="inline-flex items-center justify-center bg-[#D1D1D1] rounded mr-4 p-3 w-12">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="22"
                        viewBox="0 0 22 22"
                        fill="none"
                      >
                        <path
                          d="M19.5898 7.38075C19.1223 6.26518 18.4423 5.25121 17.5877 4.39533C16.7356 3.53798 15.7234 2.85633 14.6085 2.38908C13.4665 1.9081 12.2394 1.66155 11.0002 1.66408H10.9585C9.6981 1.67033 8.47935 1.92033 7.33143 2.412C6.22617 2.88404 5.22346 3.5669 4.37935 4.42241C3.53296 5.27636 2.86075 6.28679 2.40018 7.39741C1.9221 8.55234 1.67984 9.79122 1.68768 11.0412C1.69393 12.487 2.03977 13.9224 2.6856 15.2057V18.3724C2.6856 18.9016 3.11477 19.3307 3.64185 19.3307H6.80435C8.09367 19.9814 9.51645 20.3237 10.9606 20.3307H11.0044C12.2502 20.3307 13.4564 20.0891 14.5939 19.6162C15.7031 19.1545 16.7116 18.4808 17.5627 17.6328C18.421 16.7807 19.096 15.7849 19.5689 14.6745C20.0585 13.5245 20.3085 12.3016 20.3148 11.0391C20.3189 9.77033 20.0731 8.53908 19.5898 7.38075ZM6.84185 11.9974C6.29185 11.9974 5.84393 11.5495 5.84393 10.9974C5.84393 10.4453 6.29185 9.99741 6.84185 9.99741C7.39185 9.99741 7.83977 10.4453 7.83977 10.9974C7.83977 11.5495 7.39393 11.9974 6.84185 11.9974ZM11.0002 11.9974C10.4502 11.9974 10.0023 11.5495 10.0023 10.9974C10.0023 10.4453 10.4502 9.99741 11.0002 9.99741C11.5502 9.99741 11.9981 10.4453 11.9981 10.9974C11.9981 11.5495 11.5502 11.9974 11.0002 11.9974ZM15.1585 11.9974C14.6085 11.9974 14.1606 11.5495 14.1606 10.9974C14.1606 10.4453 14.6085 9.99741 15.1585 9.99741C15.7085 9.99741 16.1564 10.4453 16.1564 10.9974C16.1564 11.5495 15.7085 11.9974 15.1585 11.9974Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    Message sent successfully to supplier(s).
                  </Dialog.Title>
                  <div className="flex justify-center">
                    <button
                      onClick={handleCloseSuccess}
                      className="px-6 py-2 bg-[#EAF524] text-black font-medium rounded"
                    >
                      OK
                    </button>
                  </div>
                </>
              ) : (
                <>
                  <Dialog.Title
                    as="h2"
                    className="text-2xl font-semibold mb-4 flex flex-row justify-start items-center"
                  >
                    <div className="rounded bg-[#D1D1D1] p-3 mr-4">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="22"
                        viewBox="0 0 22 22"
                        fill="none"
                      >
                        <path
                          d="M19.5898 7.38075C19.1223 6.26518 18.4423 5.25121 17.5877 4.39533C16.7356 3.53798 15.7234 2.85633 14.6085 2.38908C13.4665 1.9081 12.2394 1.66155 11.0002 1.66408H10.9585C9.6981 1.67033 8.47935 1.92033 7.33143 2.412C6.22617 2.88404 5.22346 3.5669 4.37935 4.42241C3.53296 5.27636 2.86075 6.28679 2.40018 7.39741C1.9221 8.55234 1.67984 9.79122 1.68768 11.0412C1.69393 12.487 2.03977 13.9224 2.6856 15.2057V18.3724C2.6856 18.9016 3.11477 19.3307 3.64185 19.3307H6.80435C8.09367 19.9814 9.51645 20.3237 10.9606 20.3307H11.0044C12.2502 20.3307 13.4564 20.0891 14.5939 19.6162C15.7031 19.1545 16.7116 18.4808 17.5627 17.6328C18.421 16.7807 19.096 15.7849 19.5689 14.6745C20.0585 13.5245 20.3085 12.3016 20.3148 11.0391C20.3189 9.77033 20.0731 8.53908 19.5898 7.38075ZM6.84185 11.9974C6.29185 11.9974 5.84393 11.5495 5.84393 10.9974C5.84393 10.4453 6.29185 9.99741 6.84185 9.99741C7.39185 9.99741 7.83977 10.4453 7.83977 10.9974C7.83977 11.5495 7.39393 11.9974 6.84185 11.9974ZM11.0002 11.9974C10.4502 11.9974 10.0023 11.5495 10.0023 10.9974C10.0023 10.4453 10.4502 9.99741 11.0002 9.99741C11.5502 9.99741 11.9981 10.4453 11.9981 10.9974C11.9981 11.5495 11.5502 11.9974 11.0002 11.9974ZM15.1585 11.9974C14.6085 11.9974 14.1606 11.5495 14.1606 10.9974C14.1606 10.4453 14.6085 9.99741 15.1585 9.99741C15.7085 9.99741 16.1564 10.4453 16.1564 10.9974C16.1564 11.5495 15.7085 11.9974 15.1585 11.9974Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    Send Bulk Message
                  </Dialog.Title>
                  {selectedSuppliers.some(
                    (s) => !s?.misc?.isRegistrationCompleted
                  ) && (
                    <span className="text-left text-[#EB1004] text-base">
                      Some suppliers are not registered on the platform.
                      Messages will be sent to the email addresses we have on
                      file.
                    </span>
                  )}

                  {/* Subject Field */}
                  <div className="mb-3 mt-6">
                    <label className="text-sm font-medium text-gray-600">
                      Subject <span className="text-red-500">*</span>
                    </label>

                    <input
                      type="text"
                      className="w-full border rounded px-3 py-2 mt-1 bg-[#F4F4F4]"
                      value={bulkSubject}
                      onChange={(e) => setBulkSubject(e.target.value)}
                    />
                  </div>

                  <div className="mb-3">
                    <label className="text-sm font-medium text-gray-600">
                      Send To
                    </label>
                    <div className="flex flex-wrap gap-2 mt-1 max-h-32 overflow-y-auto bg-[#F4F4F4] rounded py-6 px-2">
                      {selectedSuppliers.map((s) => (
                        <div
                          key={s._id}
                          className="flex items-center bg-white rounded px-3 py-2 text-sm"
                        >
                          <span>{s.company?.name || s.name || ""}</span>
                          <button
                            onClick={() =>
                              setSelectedSuppliers((prev) =>
                                prev.filter(
                                  (supplier) => supplier._id !== s._id
                                )
                              )
                            }
                            className="ml-2 text-gray-500 hover:text-gray-700 font-bold"
                          >
                            ×
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Message Field */}
                  <div className="mb-4">
                    <label className="text-sm font-medium text-gray-600">
                      Message
                    </label>
                    <textarea
                      className="w-full bg-[#F4F4F4] rounded px-3 py-2 mt-1"
                      rows={4}
                      value={bulkMessage}
                      onChange={(e) => setBulkMessage(e.target.value)}
                    />
                  </div>

                  {/* Actions */}
                  <div className="flex justify-end gap-3">
                    <button
                      onClick={handleBulkCloseModal}
                      className="px-4 py-2 bg-[#F1F1F1] rounded"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={() => handleSendBulkMessage()}
                      disabled={!bulkSubject}
                      className={`px-4 py-2 font-medium rounded 
    ${
      bulkSubject
        ? "bg-[#EAF524] text-black"
        : "bg-gray-300 text-gray-500 cursor-not-allowed"
    }`}
                    >
                      Send
                    </button>
                  </div>
                </>
              )}
            </Dialog.Panel>
          </div>
        </Dialog>

        <Dialog
          open={isMoveToFolderActive}
          onClose={handleDone}
          className="relative"
          style={{ zIndex: 10000 }}
        >
          <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
          <div className="fixed inset-0 flex items-center justify-center p-4">
            <Dialog.Panel className="w-full max-w-lg rounded-xl bg-white p-8 shadow-lg">
              {step === 1 ? (
                <>
                  <div className="flex items-center mb-2">
                    <div className="bg-[#D1D1D1] p-2 rounded-lg mr-3">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M1 2.5H9.48L11.48 5H23V21H1V2.5ZM3 4.5V19H21V7H10.52L8.52 4.5H3Z"
                          fill="white"
                        />
                        <path
                          d="M8 11.9999H12.657L11.191 10.4699L12.636 9.08594L16.385 12.9999L12.635 16.9139L11.191 15.5299L12.657 14.0009H8V11.9999Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <Dialog.Title className="text-2xl font-semibold text-[#1D2739">
                      Move {selectedCompany && selectedCompany.company.name} to
                      a folder
                    </Dialog.Title>
                  </div>

                  <p className={`text-sm text-[#1D2739] ${error ? "mb-2" : "mb-10"}`}>
                    Choose the folder where you want to move this supplier(s).
                  </p>

                  {error && (
                    <p className="text-sm text-red-500 mb-10">{error}</p>
                  )}

                  <div className="space-y-6 mb-6">
                    {folders?.map((folder) => (
                      <label
                        key={folder.id}
                        className="flex items-center space-x-2 cursor-pointer"
                      >
                        <input
                          type="checkbox"
                          className="shadow-lg shadow-gray-400"
                          checked={selectedFolder === folder.name}
                          onChange={() => setSelectedFolder(folder.name)}
                        />

                        <span className="flex flex-row justify-start items-center text-base">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            className="ml-4 mr-2"
                          >
                            <path
                              d="M4 20C3.45 20 2.97933 19.8043 2.588 19.413C2.19667 19.0217 2.00067 18.5507 2 18V6C2 5.45 2.196 4.97933 2.588 4.588C2.98 4.19667 3.45067 4.00067 4 4H9.175C9.44167 4 9.696 4.05 9.938 4.15C10.18 4.25 10.3923 4.39167 10.575 4.575L12 6H20C20.55 6 21.021 6.196 21.413 6.588C21.805 6.98 22.0007 7.45067 22 8V18C22 18.55 21.8043 19.021 21.413 19.413C21.0217 19.805 20.5507 20.0007 20 20H4ZM4 18H20V8H11.175L9.175 6H4V18Z"
                              fill="#1D2739"
                            />
                          </svg>
                          {folder.name}
                        </span>
                      </label>
                    ))}
                  </div>

                  <div className="flex justify-end space-x-3">
                    <button
                      className="px-4 py-2 rounded-md bg-[#F1F1F1] text-[#1D2739]"
                      onClick={handleDone}
                    >
                      Cancel
                    </button>
                    <button
                      className="px-4 py-2 rounded-md bg-[#EAF524] font-medium"
                      onClick={() => handleMove()}
                    >
                      Move
                    </button>
                  </div>
                </>
              ) : (
                <div className="text-center">
                  <div className="flex justify-center mb-4">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="48"
                      height="48"
                      viewBox="0 0 48 48"
                      fill="none"
                    >
                      <path
                        d="M24 3C29.5695 3 34.911 5.21249 38.8492 9.15076C42.7875 13.089 45 18.4305 45 24C45 29.5695 42.7875 34.911 38.8492 38.8492C34.911 42.7875 29.5695 45 24 45C18.4305 45 13.089 42.7875 9.15076 38.8492C5.21249 34.911 3 29.5695 3 24C3 18.4305 5.21249 13.089 9.15076 9.15076C13.089 5.21249 18.4305 3 24 3ZM21.384 28.143L16.719 23.475C16.5518 23.3078 16.3532 23.1751 16.1347 23.0846C15.9162 22.9941 15.682 22.9475 15.4455 22.9475C15.209 22.9475 14.9748 22.9941 14.7563 23.0846C14.5378 23.1751 14.3392 23.3078 14.172 23.475C13.8342 23.8128 13.6445 24.2708 13.6445 24.7485C13.6445 25.2262 13.8342 25.6842 14.172 26.022L20.112 31.962C20.2788 32.1301 20.4772 32.2635 20.6957 32.3545C20.9143 32.4456 21.1487 32.4924 21.3855 32.4924C21.6223 32.4924 21.8567 32.4456 22.0753 32.3545C22.2938 32.2635 22.4922 32.1301 22.659 31.962L34.959 19.659C35.1285 19.4925 35.2633 19.294 35.3557 19.0751C35.4481 18.8562 35.4962 18.6211 35.4973 18.3835C35.4984 18.1459 35.4525 17.9105 35.3621 17.6907C35.2718 17.4709 35.1388 17.2712 34.9709 17.1031C34.803 16.935 34.6034 16.8018 34.3838 16.7112C34.1641 16.6206 33.9287 16.5744 33.6911 16.5752C33.4535 16.576 33.2184 16.6239 32.9994 16.716C32.7804 16.8081 32.5817 16.9427 32.415 17.112L21.384 28.143Z"
                        fill="#0088FF"
                      />
                    </svg>
                  </div>
                  <h2 className="text-lg font-semibold mb-2">
                    {selectedCompany && selectedCompany.company.name} Moved to
                    Different Folder
                  </h2>
                  <p className="text-gray-500 text-sm mb-6 px-6">
                    The selected supplier have been successfully Moved to the
                    folder: <strong>{selectedFolder}</strong>.
                  </p>
                  <button
                    className="w-[80%] bg-[#EAF524] py-2 rounded-md font-medium mt-4"
                    onClick={handleDone}
                  >
                    Done
                  </button>
                </div>
              )}
            </Dialog.Panel>
          </div>
        </Dialog>

        {isUserProfileOpen && <Overlay />}
        {selectedCard && (
          <div
            className="additional-bar"
            style={{
              width: "500px",
              position: "fixed",
              right: 0,
              top: 0,
              height: "100vh",
              background: "white",
              zIndex: 1100,
            }}
          >
            <UserProfileComponent
              onClose={handleCloseUserProfile}
              backUrl="/dashboard/management"
              management={true}
            />
          </div>
        )}

        {isImportCompleted && (
          <>
            <Overlay />
            <div className="popup-import-container">
              <div className="inline-flex flex-col px-[51px] pb-[34px] w-[618px] max-h-[80vh] rounded-[8px] bg-white shadow-md mt-[60px] overflow-y-auto">
                <p className="mt-4 mb-2 text-left">AI RFP Summary text</p>
                {!analyzing && (
                  <p className="text-left text-[#7B7B7B]">{summaryText}</p>
                )}

                <div className="mt-4 flex">
                  <button
                    className="text-[#7B7B7B] flex flex-row justify-start items-center text-[19px] bg-[rgba(227,227,227,0.63)] py-[7px] px-[10px] rounded-lg"
                    onClick={regenerateText}
                  >
                    {analyzing ? "Analyzing" : "Regenerate"}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="13"
                      height="12"
                      viewBox="0 0 13 12"
                      fill="none"
                      className={`ml-2 ${analyzing ? "animate-spin" : ""}`}
                    >
                      <g clip-path="url(#clip0_339_17900)">
                        <path
                          d="M11.5 6C11.5 9 9.305 11 6.597 11C4.396 11 2.62 9.8325 2 8M1.5 6C1.5 3 3.695 1 6.4035 1C8.604 1 10.379 2.1675 11 4"
                          stroke="#7B7B7B"
                          stroke-width="1.33333"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M4 8.5L2 8L1.5 10M9 3.5L11 4L11.5 2"
                          stroke="#7B7B7B"
                          stroke-width="1.33333"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_339_17900">
                          <rect
                            width="12"
                            height="12"
                            fill="white"
                            transform="translate(0.5)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </button>
                </div>

                <div className="bottom-buttons">
                  <button onClick={closePopUp} className="cancel-button">
                    Cancel
                  </button>
                  <button
                    onClick={onNext}
                    disabled={analyzing}
                    className={`flex justify-center items-center rounded-[3.797px] w-[76.897px] h-[31.328px] px-[11.392px] py-[5.696px] outline-none border-none ${
                      analyzing
                        ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                        : "bg-[#EAF524] text-black"
                    }`}
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          </>
        )}

        {(isSummuryGenerated || isSearchTrigered) && (
          <>
            <Overlay />
            <div className="popup-import-container">
              <div className="flex justify-center items-center flex-col px-[51px] pb-[34px] w-[618px] h-[415px] rounded-[8px] bg-white shadow-md mt-[60px] overflow-y-auto">
                <div className="flex justify-center items-center flex-col">
                  <img
                    src={rfpIcon}
                    alt="rfp icon"
                    className="spinning mb-4"
                  ></img>
                  <span className="text-[#1D2739] text-base flex justify-center items-center text-center">
                    {isSearchTrigered
                      ? "Searching recommendations..."
                      : "Generating recommendations..."}
                  </span>
                </div>
              </div>
            </div>
          </>
        )}

        {(isPendingOpen ? totalPendingSuppliers > 0 : totalSuppliers > 0) && (
          <div className="mt-60">
            <PaginationBar
              currentPage={currentPage}
              totalPages={Math.ceil(
                isPendingOpen
                  ? totalPendingSuppliers / itemsPerPage
                  : isRecommendedSuppliersLoaded
                  ? recommendedSuppliers.length / itemsPerPage
                  : totalSuppliers / itemsPerPage
              )}
              handlePageChange={handlePageChange}
              paginationBarStyle={paginationBarStyle}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default CompanyTable;
